/* Atman theme — light interactions */
(function () {
  // Mobile make-nav: off-canvas side drawer (burger + close button + scrim all carry data-burger)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-burger]');
    if (b) {
      e.preventDefault();
      var nav = document.querySelector('.makenav');
      if (nav) {
        var open = nav.classList.toggle('open');
        document.body.style.overflow = open ? 'hidden' : '';
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var nav = document.querySelector('.makenav.open');
      if (nav) { nav.classList.remove('open'); document.body.style.overflow = ''; }
    }
  });

  // ---- Custom dropdown: replace the native OS <select> picker with an on-brand popup.
  // Handles selects whose <option>s are filled/rebuilt later (e.g. cascading Year→Model→Trim). ----
  function enhanceSelect(sel) {
    if (sel.dataset.enhanced) return;
    sel.dataset.enhanced = '1';
    var wrap = document.createElement('div');
    wrap.className = 'csel';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'csel-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var lbl = document.createElement('span');
    lbl.className = 'csel-lbl';
    btn.appendChild(lbl);
    btn.insertAdjacentHTML('beforeend', '<svg class="csel-chev" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    var menu = document.createElement('ul');
    menu.className = 'csel-menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    var inp = null;
    if (sel.hasAttribute('data-search')) {
      inp = document.createElement('input');
      inp.type = 'text'; inp.className = 'csel-search'; inp.autocomplete = 'off'; inp.spellcheck = false; inp.hidden = true;
      inp.setAttribute('role', 'combobox'); inp.setAttribute('aria-autocomplete', 'list'); inp.setAttribute('aria-label', sel.getAttribute('aria-label') || 'Search');
    }
    function open() {
      document.querySelectorAll('.csel.open').forEach(function (o) {
        if (o === wrap) return;
        o.classList.remove('open');
        var m = o.querySelector('.csel-menu'); if (m) m.hidden = true;
        var b = o.querySelector('.csel-btn'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      menu.hidden = false; wrap.classList.add('open'); btn.setAttribute('aria-expanded', 'true');
      if (inp) {
        // Поле с поиском (data-search): вместо названия появляется строка ввода, в подсказке название поля («Model»).
        var cs = getComputedStyle(btn);
        inp.style.paddingLeft = cs.paddingLeft; inp.style.fontSize = cs.fontSize; inp.style.color = cs.color;
        var first = sel.options[0];
        inp.placeholder = sel.getAttribute('data-search-ph') || (first && first.value === '' ? first.text : (sel.getAttribute('aria-label') || ''));
        inp.value = ''; inp.hidden = false; wrap.classList.add('searching');
        build('');
        inp.focus();
      }
    }
    function close() {
      var was = !menu.hidden;
      menu.hidden = true; wrap.classList.remove('open'); btn.setAttribute('aria-expanded', 'false');
      if (inp && was) { inp.hidden = true; inp.value = ''; wrap.classList.remove('searching'); build(''); }
    }
    // (Re)build the popup from the select's current options + label.
    function build(q) {
      var o = sel.options[sel.selectedIndex];
      lbl.textContent = o ? o.text : '';
      menu.innerHTML = '';
      var list = [].slice.call(sel.options).filter(function (opt) { return !(opt.disabled || opt.value === ''); }); // placeholder stays in the field, not in the list
      // Поиск по набранному: сначала названия, которые НАЧИНАЮТСЯ с набранного («7» → 730d, 733i, 740e…), потом те, где оно
      // встречается внутри («440» → M440i); внутри группы по возрастанию («74» → 740e, 740i, 740Li…).
      var query = inp && typeof q === 'string' ? q.replace(/[\s\-]+/g, '').toLowerCase().replace(/^bmw(?=[a-z0-9])/, '') : '';
      if (query) {
        var ranked = [];
        list.forEach(function (opt) {
          var t = opt.text.replace(/[\s\-]+/g, '').toLowerCase().replace(/^bmw(?=[a-z0-9])/, ''), at = t.indexOf(query); // «BMW F30»: ищем по коду, слово BMW не мешает
          if (at === 0) ranked.push([0, opt]); else if (at > 0) ranked.push([1, opt]);
        });
        ranked.sort(function (a, b) { return a[0] - b[0] || a[1].text.localeCompare(b[1].text, 'en', { numeric: true }); });
        list = ranked.map(function (r) { return r[1]; });
        if (!list.length) { var em = document.createElement('li'); em.className = 'csel-empty'; em.textContent = 'No matches'; menu.appendChild(em); }
      }
      list.forEach(function (opt, idx) {
        var li = document.createElement('li');
        li.className = 'csel-opt';
        li.setAttribute('role', 'option');
        li.textContent = opt.text;
        li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
        if (query && idx === 0) li.classList.add('hl');
        li.addEventListener('click', function () {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          build('');
          close();
        });
        menu.appendChild(li);
      });
    }
    build('');
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (menu.hidden) open(); else close(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    sel.addEventListener('change', function () { build(inp && !inp.hidden ? inp.value : ''); });
    // Rebuild when the option list is replaced programmatically (cascading dropdowns).
    if (window.MutationObserver) new MutationObserver(function () { build(inp && !inp.hidden ? inp.value : ''); }).observe(sel, { childList: true });
    if (inp) {
      inp.addEventListener('input', function () { build(inp.value); });
      inp.addEventListener('keydown', function (e) {
        var opts = [].slice.call(menu.querySelectorAll('.csel-opt')), cur = menu.querySelector('.csel-opt.hl');
        var i = opts.indexOf(cur);
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (!opts.length) return;
          i = e.key === 'ArrowDown' ? Math.min(i + 1, opts.length - 1) : Math.max(i - 1, 0);
          opts.forEach(function (x) { x.classList.remove('hl'); });
          opts[i].classList.add('hl'); opts[i].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter') {
          e.preventDefault(); // Enter в строке поиска не должен отправлять форму
          var pick = cur || opts[0];
          if (pick) pick.click();
        } else if (e.key === 'Escape') {
          e.preventDefault(); e.stopPropagation(); // закрываем только список, не окно вокруг него
          close(); btn.focus();
        } else if (e.key === 'Tab') {
          close();
        }
      });
    }
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(btn);
    if (inp) wrap.appendChild(inp);
    wrap.appendChild(menu);
    sel.classList.add('csel-native');
  }
  [].slice.call(document.querySelectorAll('select[data-enhance]')).forEach(enhanceSelect);

  // 15.10.2026: VIN в тексте запроса на сервер не отправляем (правило: VIN нигде не сохраняется). Любой VIN (17 знаков без I, O, Q,
  // с цифрой и буквой), подряд или группами через пробел/дефис, в любом месте фразы, заменяется на [VIN]. Обычные запросы,
  // номера деталей и коды кузова не меняются: аналитика поиска остаётся.
  function atVinRedact(s) {
    s = String(s == null ? '' : s);
    var isVin = function (v) { return /^[A-HJ-NPR-Z0-9]{17}$/i.test(v) && /\d/.test(v) && /[A-Za-z]/.test(v); };
    var re = /[A-Za-z0-9]+/g, toks = [], m;
    while ((m = re.exec(s))) toks.push({ s: m.index, e: m.index + m[0].length, t: m[0] });
    var out = '', pos = 0, i = 0, j, hit, joined, minLen;
    while (i < toks.length) {
      hit = -1; joined = ''; minLen = 99;
      for (j = i; j < toks.length && j < i + 5; j++) {
        if (j > i && !/^[ \- ]$/.test(s.slice(toks[j - 1].e, toks[j].s))) break;
        joined += toks[j].t; minLen = Math.min(minLen, toks[j].t.length);
        if (joined.length > 17) break;
        // подряд идущие 17 знаков: достаточно формата VIN; разделённые пробелами или дефисами: ещё части не короче 3 знаков, 9-й знак цифра или X, последние 4 знака цифры
        if (joined.length === 17 && isVin(joined) && (j === i || (minLen >= 3 && /^[0-9X]$/i.test(joined.charAt(8)) && /\d{4}$/.test(joined) &&
            toks.slice(i, j + 1).every(function (x) { return !/^\d{9,}$/.test(x.t) && (/\d/.test(x.t) || x.t.length <= 3); })))) { hit = j; break; }
      }
      if (hit >= 0) { out += s.slice(pos, toks[i].s) + '[VIN]'; pos = toks[hit].e; i = hit + 1; } else { i++; }
    }
    return out + s.slice(pos);
  }
  window.atVinRedact = atVinRedact;

  // Номер детали в любом написании (11.10.2026): «71 11 6 752 543», «7111-6752-543», «OE 71116752543» — для поиска
  // это одна и та же строка из цифр. Нормализуем, только если запрос целиком состоит из номера (7+ цифр);
  // «2008 2012» (годы) и обычные слова не трогаем.
  function atNormPart(q) {
    var s = String(q || '').trim();
    var m = /^(?:oem?\s*[#:]?\s*|#\s*)?(\d[\d\s.\-\/]{5,})$/i.exec(s);
    if (!m) return s;
    if (/^(19|20)\d\d(\s+(19|20)\d\d)+$/.test(m[1].trim())) return s;
    var digits = m[1].replace(/\D/g, '');
    return digits.length >= 7 ? digits : s;
  }

  // Ссылка вида /search?q=7111 6752543 (закладка, чужой сайт, письмо): ведём на номер без пробелов.
  if (/^\/search\/?$/.test(location.pathname)) {
    try {
      var rsp = new URLSearchParams(location.search), rq = rsp.get('q') || '';
      if (rq && atNormPart(rq) !== rq) { rsp.set('q', atNormPart(rq)); location.replace('/search?' + rsp.toString()); }
    } catch (e) {}
  }

  // Запомненная машина клиента (10.10.2026). Хранится только в браузере (localStorage), на сервере ничего.
  // Год / модель / комплектация — в тех же названиях, что в таблице совместимости товара, поэтому
  // на любой карточке вердикт «подходит / не указано» считается сразу, без повторного выбора.
  var CAR_KEY = 'atman_car', carMem = null;
  function carGet() {
    try {
      var c = JSON.parse(localStorage.getItem(CAR_KEY) || 'null');
      if (c && c.y && c.m) return c;
    } catch (e) {}
    return carMem && carMem.y && carMem.m ? carMem : null;
  }
  function carLabel(c) { return c.y + ' BMW ' + c.m + (c.t ? ' · ' + c.t : ''); }
  function carPaint() {
    var c = carGet();
    [].slice.call(document.querySelectorAll('[data-car-chip]')).forEach(function (chip) {
      chip.hidden = !c;
      var l = chip.querySelector('[data-car-label]');
      if (l) l.textContent = c ? c.y + ' BMW ' + c.m : ''; // комплектация длинная: в шапке без неё, полностью — в подсказке
      chip.title = c ? carLabel(c) : '';
    });
    [].slice.call(document.querySelectorAll('[data-car-add]')).forEach(function (b) { b.hidden = !!c; });
  }
  // Выбор машины = сигнал спроса (11.10.2026): пишем «год BMW модель» в тот же сборщик, что и поиск (atman-track/log.php, тип car).
  // Штаб показывает это отдельным блоком «Какие машины выбирают» вместе с числом наших деталей: так видно машины, которые
  // выбирают, а деталей у нас нет. Пишется только год и модель: ни имя, ни email, ни VIN. Повторный выбор той же машины не считаем;
  // машина, подхваченная из аккаунта автоматически (silent), выбором покупателя не считается.
  function carLog(c) {
    try {
      var prev = carGet();
      if (prev && prev.y === c.y && prev.m === c.m) return;
      var payload = JSON.stringify({ q: c.y + ' BMW ' + c.m, n: null, k: 'car' });
      var url = 'https://shtab.atman-parts.com/atman-track/log.php';
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' }));
      else fetch(url, { method: 'POST', body: payload, mode: 'no-cors', keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  function carSet(c, silent) {
    if (!silent) carLog(c);
    carMem = c;
    try { localStorage.setItem(CAR_KEY, JSON.stringify(c)); } catch (e) {}
    carPaint();
    document.dispatchEvent(new CustomEvent('atman:car'));
  }
  function carClear() {
    carMem = null;
    try { localStorage.removeItem(CAR_KEY); } catch (e) {}
    carPaint();
    document.dispatchEvent(new CustomEvent('atman:car'));
  }
  [].slice.call(document.querySelectorAll('[data-car-clear]')).forEach(function (b) { b.addEventListener('click', carClear); });
  window.addEventListener('storage', function (e) { if (e.key === CAR_KEY) { carPaint(); document.dispatchEvent(new CustomEvent('atman:car')); } });
  carPaint();

  // Машина из аккаунта (11.10.2026): вошедший клиент указывает машину в блоке «My car» кабинета (метаполя custom.car_year / car_model /
  // car_trim, приложение Fieldly); тема печатает их в [data-account-car], а здесь они становятся «Your car» на любом устройстве.
  // Подхватываем, когда машины в браузере нет или данные в аккаунте изменились (подпись год|модель|комплектация).
  // В обратную сторону (из сайта в аккаунт) передать нельзя, поэтому окно выбора ведёт в кабинет. Названия сверяем со списком
  // машин без учёта регистра и пробелов («320I» → «320i»), чтобы вердикт «Fits your car» совпал с таблицами.
  (function () {
    var el = document.querySelector('[data-account-car]');
    if (!el) return;
    var y = (el.getAttribute('data-y') || '').trim(), m = (el.getAttribute('data-m') || '').trim(), t = (el.getAttribute('data-t') || '').trim();
    if (!/^\d{4}$/.test(y) || !m) return;
    var sig = y + '|' + m + '|' + t, SIGKEY = 'atman_account_car', last = null;
    try { last = localStorage.getItem(SIGKEY); } catch (e) {}
    if (carGet() && last === sig) return;
    function nz(s) { return String(s).toLowerCase().replace(/[\s\-]+/g, ''); }
    function adopt(c) { carSet(c, true); try { localStorage.setItem(SIGKEY, sig); } catch (e) {} }
    var addBtn = document.querySelector('[data-car-add]'), src = addBtn ? addBtn.getAttribute('data-src') : '';
    if (!src) { adopt({ y: y, m: m, t: t }); return; }
    fetch(src).then(function (r) { return r.json(); }).then(function (list) {
      var ms = list[y] || {}, mm = m, tt = t;
      Object.keys(ms).some(function (k) { if (nz(k) === nz(m)) { mm = k; return true; } return false; });
      if (ms[mm] && tt) ms[mm].some(function (k) { if (nz(k) === nz(tt)) { tt = k; return true; } return false; });
      adopt({ y: y, m: mm, t: tt });
    }).catch(function () { adopt({ y: y, m: m, t: t }); });
  })();

  // Выбор машины из шапки, без захода в карточку (11.10.2026). Список год → модель → комплектация лежит в
  // assets/car-list.json (из базы совместимости: только BMW и только то, что есть у активных деталей);
  // грузится при первом открытии окна, а не с каждой страницей.
  (function () {
    var add = document.querySelector('[data-car-add]'), pop = document.querySelector('[data-car-pop]');
    if (!add || !pop) return;
    var yEl = pop.querySelector('[data-cp-year]'), mEl = pop.querySelector('[data-cp-model]'), tEl = pop.querySelector('[data-cp-trim]');
    var goEl = pop.querySelector('[data-cp-go]'), msgEl = pop.querySelector('[data-cp-msg]');
    var list = null, loading = null;
    function load() {
      if (list) return Promise.resolve(list);
      if (!loading) loading = fetch(add.getAttribute('data-src')).then(function (r) { return r.json(); })
        .then(function (j) { list = j; return j; }).catch(function () { loading = null; return null; });
      return loading;
    }
    function fill(sel, values, ph, keep) {
      var cur = keep === undefined ? sel.value : keep;
      sel.innerHTML = '';
      var o0 = document.createElement('option'); o0.value = ''; o0.textContent = ph; sel.appendChild(o0);
      values.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); });
      sel.value = values.indexOf(cur) >= 0 ? cur : '';
    }
    function sorted(a, numeric) {
      return a.slice().sort(numeric ? function (x, y) { return y - x; } : function (x, y) { return x.localeCompare(y, 'en', { numeric: true }); });
    }
    // Модели видны сразу (все, что есть в списке); выбранный год сужает их до моделей этого года.
    // Комплектации: для выбранной модели из выбранного года, а если года нет, то из всех лет.
    function refresh() {
      if (!list) return;
      fill(yEl, sorted(Object.keys(list), true), 'Year');
      var ms = {};
      (yEl.value && list[yEl.value] ? [yEl.value] : Object.keys(list)).forEach(function (y) { Object.keys(list[y]).forEach(function (m) { ms[m] = 1; }); });
      fill(mEl, sorted(Object.keys(ms)), 'Model');
      var ts = {};
      if (mEl.value) (yEl.value && list[yEl.value] ? [yEl.value] : Object.keys(list)).forEach(function (y) { (list[y][mEl.value] || []).forEach(function (t) { ts[t] = 1; }); });
      fill(tEl, sorted(Object.keys(ts)), 'Trim');
    }
    yEl.addEventListener('change', refresh);
    mEl.addEventListener('change', refresh);
    function open() {
      pop.hidden = false; add.setAttribute('aria-expanded', 'true'); msgEl.hidden = true;
      load().then(function (l) {
        if (!l) { msgEl.textContent = 'Could not load the car list. Please try again.'; msgEl.hidden = false; return; }
        var c = carGet();
        fill(yEl, sorted(Object.keys(l), true), 'Year', c ? c.y : '');
        refresh();
        if (c) { mEl.value = c.m; refresh(); tEl.value = c.t || ''; }
        [yEl, mEl, tEl].forEach(function (s) { s.dispatchEvent(new Event('change')); });
      });
    }
    function close() { pop.hidden = true; add.setAttribute('aria-expanded', 'false'); }
    function toggle(e) { e.preventDefault(); e.stopPropagation(); if (pop.hidden) open(); else close(); }
    add.addEventListener('click', toggle);
    [].slice.call(document.querySelectorAll('[data-car-edit]')).forEach(function (b) { b.addEventListener('click', toggle); });
    // Путь события берём при самом клике: пункт списка уже вынут из разметки (список перестроился) и pop.contains() его не найдёт.
    document.addEventListener('click', function (e) {
      if (pop.hidden) return;
      var path = e.composedPath ? e.composedPath() : [];
      if (path.indexOf(pop) < 0 && path.indexOf(add) < 0) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    // Поиск по VIN (11.10.2026). Год, модель и комплектацию отдаёт открытая база NHTSA vPIC (запрос идёт из браузера покупателя,
    // ключа нет, CORS открыт), дальше сверяем с car-list.json. VIN нигде не сохраняем: в atman_car уходят только год / модель / комплектация.
    // Модель точно одна -> сохраняем сразу; несколько (например «750Li, Alpina B7») -> кнопки на выбор; нет такой машины среди
    // деталей -> говорим об этом, машину не запоминаем. Не BMW и ошибка контрольной цифры не сохраняются.
    var vinEl = pop.querySelector('[data-cp-vin]'), vinGo = pop.querySelector('[data-cp-vin-go]');
    var vmsg = pop.querySelector('[data-cp-vmsg]'), pick = pop.querySelector('[data-cp-pick]');
    // Куда выводить сообщения и варианты: в окне шапки или во встроенной строке блока совместимости (11.10.2026).
    // Точка входа каждый раз задаёт UI сама (popUI / fitUI), поэтому после ранних выходов из vlook ничего не остаётся «чужим».
    var popUI = { inp: vinEl, go: vinGo, msg: vmsg, pick: pick, inline: false }, fitUI = null, UI = popUI;
    function vn(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    function vsay(text, bad, linkText, linkHref) {
      UI.msg.textContent = text; UI.msg.className = 'car-vin-msg' + (bad ? ' bad' : '');
      if (linkText) { UI.msg.appendChild(document.createTextNode(' ')); var a = document.createElement('a'); a.href = linkHref; a.textContent = linkText; UI.msg.appendChild(a); }
      UI.msg.hidden = !text;
      if (bad && vsrc) vopen();
    }
    // VIN, введённый в строке поиска (11.10.2026): удачу показываем уведомлением, а ошибку и выбор из двух вариантов — в окне машины.
    var vsrc = null;
    function vopen() { if (pop.hidden) open(); try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); } }
    function vtoast(msg) {
      var t = document.createElement('div'); t.className = 'toast'; t.textContent = msg; document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('on'); });
      setTimeout(function () { t.classList.remove('on'); setTimeout(function () { t.remove(); }, 300); }, 4200);
    }
    function vsave(y, m, t) {
      UI.pick.hidden = true; vsay('', false); UI.inp.value = ''; carSet({ y: y, m: m, t: t || '' }); close();
      if (UI.inline && fitWrap) fitWrap.hidden = true; // машина определена по VIN: поле ввода убираем, вернётся по «Check another vehicle»
      if (vsrc) {
        var s = vsrc; vsrc = null;
        var done = 'Saved: ' + y + ' BMW ' + m + (t ? ' \u00b7 ' + t : '') + '. Now search for the part you need.';
        // Страница «0 результатов по VIN» покупателю ни к чему: уходим на главную, уведомление покажем там.
        if (s.land) { try { sessionStorage.setItem('atman_vin_toast', done); } catch (e) {} location.replace('/'); return; }
        if (s.value !== undefined) s.value = '';
        var acBox = document.querySelector('[data-ac]'); if (acBox) acBox.hidden = true; // подсказки поиска «No matches yet» под пустой строкой не нужны
        if (s.setAttribute) s.setAttribute('aria-expanded', 'false');
        vtoast(done);
        try { if (s.focus) s.focus(); } catch (e) {}
      }
    }
    function vmatch(l, x) {
      var y = String(x.ModelYear || ''), models = l[y] ? Object.keys(l[y]) : [];
      if (!models.length) return { none: true, y: y };
      var parts = String(x.Model || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var dm = /\b[xs]drive\b/i.exec(String(x.Trim || '')), drv = dm ? dm[0] : '', cands = [];
      function add(m) { if (m && cands.indexOf(m) < 0) cands.push(m); }
      parts.forEach(function (p) {
        var hit = null;
        if (drv) models.forEach(function (m) { if (!hit && vn(m) === vn(p + ' ' + drv)) hit = m; });
        if (!hit) models.forEach(function (m) { if (!hit && vn(m) === vn(p)) hit = m; });
        add(hit);
      });
      if (!cands.length) {
        parts.forEach(function (p) { models.forEach(function (m) { if (vn(m).indexOf(vn(p)) === 0) add(m); }); });
        if (drv) { var d = cands.filter(function (m) { return vn(m).indexOf(vn(drv)) >= 0; }); if (d.length) cands = d; }
      }
      if (!cands.length) return { none: true, y: y };
      var t = vn(x.Trim), tm = [];
      if (cands.length === 1 && t) (l[y][cands[0]] || []).forEach(function (tr) { if (vn(tr).indexOf(t) >= 0) tm.push(tr); });
      return { y: y, models: cands, trim: tm.length === 1 ? tm[0] : '' };
    }
    function vlook(src) {
      vsrc = src || null;
      var vin = UI.inp.value.replace(/[\s-]/g, '').toUpperCase();
      UI.pick.hidden = true; UI.pick.innerHTML = '';
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) { vsay('A VIN has 17 characters: digits and letters, without I, O or Q. Please check it.', true); return; }
      vsay('Looking up your VIN\u2026', false); UI.go.disabled = true;
      var ctl = window.AbortController ? new AbortController() : null, to = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
      Promise.all([load(), fetch('https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/' + vin + '?format=json', ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); })])
        .then(function (res) {
          var l = res[0], x = res[1] && res[1].Results && res[1].Results[0];
          if (!l || !x) throw new Error('no data');
          var codes = String(x.ErrorCode || '').split(',').map(function (s) { return s.trim(); });
          if (!x.Make || !x.Model || !x.ModelYear) { vsay('We could not identify this VIN. Please check it or choose your car below.', true); return; }
          if (codes.indexOf('1') >= 0) { vsay('This VIN does not look right (the check digit does not match). Please check it.', true); return; }
          if (String(x.Make).toUpperCase() !== 'BMW') { vsay('This VIN is for a ' + x.ModelYear + ' ' + x.Make + ' ' + x.Model + '. We sell BMW parts only.', true); return; }
          var r = vmatch(l, x);
          if (r.none) { vsay('We found a ' + x.ModelYear + ' BMW ' + x.Model + ', but there are no parts listed for it right now.', true, 'Tell us what you need', '/pages/contact'); return; }
          if (r.models.length === 1) { vsave(r.y, r.models[0], r.trim); return; }
          vsay('Which one is yours?', false);
          if (vsrc) vopen();
          r.models.forEach(function (m) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'car-pick-b'; b.textContent = r.y + ' BMW ' + m;
            b.addEventListener('click', function () { vsave(r.y, m, ''); });
            UI.pick.appendChild(b);
          });
          UI.pick.hidden = false;
        })
        .catch(function () { vsay('Could not look up this VIN right now. Please choose your car below.', true); })
        .then(function () { clearTimeout(to); UI.go.disabled = false; });
    }
    function vlookPop(src) { UI = popUI; vlook(src); }
    vinGo.addEventListener('click', function () { vlookPop(); });
    vinEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); vlookPop(); } });
    // Поле VIN прямо в блоке «Will this fit your BMW?» на карточке (11.10.2026), видно сразу: тот же разбор, но сообщения и выбор из двух
    // вариантов показываем тут же, окно шапки не открываем и страницу не прокручиваем. Ссылка есть и под полями, и под вердиктом.
    var fitBox = document.querySelector('[data-fit-vin-box]');
    var fitWrap = document.querySelector('.fit-vin-wrap');
    document.addEventListener('click', function (e) {
      if (fitWrap && e.target && e.target.closest && e.target.closest('[data-fit-reset]')) fitWrap.hidden = false;
    });
    if (fitBox) {
      var fIn = fitBox.querySelector('[data-fit-vin-input]'), fGo = fitBox.querySelector('[data-fit-vin-go]');
      fitUI = { inp: fIn, go: fGo, msg: fitBox.querySelector('[data-fit-vin-msg]'), pick: fitBox.querySelector('[data-fit-vin-pick]'), inline: true };
      function flook() { UI = fitUI; vlook(); }
      fGo.addEventListener('click', flook);
      fIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); flook(); } });
      [].slice.call(document.querySelectorAll('[data-fit-vin]')).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var choose = document.querySelector('[data-fit-step="choose"]'), rs = document.querySelector('[data-fit-reset]');
          if (choose && choose.hidden && rs) rs.click(); // из вердикта возвращаемся к выбору, курсор ставим в поле VIN (оно на карточке видно всегда)
          setTimeout(function () { try { fIn.focus({ preventScroll: true }); } catch (x) { fIn.focus(); } }, 50);
        });
      });
    }
    // Блок «My vehicle» на страницах каталога (12.10.2026): год / модель / комплектация и VIN, как в карточке товара. Машина
    // запоминается так же, как из шапки; через 20 секунд после сохранения показываем окно «регистрация и 10%».
    var mvBox = document.querySelector('[data-mv-car]');
    if (mvBox) (function () {
      var my = mvBox.querySelector('[data-mv-year]'), mm = mvBox.querySelector('[data-mv-model]'), mt = mvBox.querySelector('[data-mv-trim]');
      var go = mvBox.querySelector('[data-mv-go]'), msg = mvBox.querySelector('[data-mv-msg]');
      var fields = mvBox.querySelector('[data-mv-fields]'), saved = mvBox.querySelector('[data-mv-saved]'), savedT = mvBox.querySelector('[data-mv-saved-t]');
      var boxUI = { inp: mvBox.querySelector('[data-mv-vin]'), go: mvBox.querySelector('[data-mv-vin-go]'), msg: mvBox.querySelector('[data-mv-vmsg]'), pick: mvBox.querySelector('[data-mv-pick]'), inline: true };
      var pendAt = 0, syncing = false;
      function say(t) { msg.textContent = t; msg.hidden = !t; }
      function sync() { syncing = true; [my, mm, mt].forEach(function (s) { s.dispatchEvent(new Event('change')); }); syncing = false; }
      function refreshBox() {
        if (!list) return;
        fill(my, sorted(Object.keys(list), true), 'Year');
        var ms = {};
        (my.value && list[my.value] ? [my.value] : Object.keys(list)).forEach(function (y) { Object.keys(list[y]).forEach(function (m) { ms[m] = 1; }); });
        fill(mm, sorted(Object.keys(ms)), 'Model');
        var ts = {};
        if (mm.value) (my.value && list[my.value] ? [my.value] : Object.keys(list)).forEach(function (y) { (list[y][mm.value] || []).forEach(function (t) { ts[t] = 1; }); });
        fill(mt, sorted(Object.keys(ts)), 'Trim');
      }
      function ensure() { return load().then(function (l) { if (l) { refreshBox(); sync(); } return l; }); }
      function paint() {
        var c = carGet();
        saved.hidden = !c; fields.hidden = !!c;
        if (c) savedT.textContent = carLabel(c);
      }
      [my, mm].forEach(function (s) { s.addEventListener('change', function () { if (!syncing) { refreshBox(); } }); });
      mvBox.addEventListener('pointerdown', ensure, { once: true });
      mvBox.addEventListener('focusin', ensure, { once: true });
      if (window.requestIdleCallback) requestIdleCallback(ensure); else setTimeout(ensure, 2000);
      go.addEventListener('click', function () {
        if (!my.value || !mm.value) { say('Pick a year and a model.'); return; }
        if (mt.options.length > 1 && !mt.value) { say('Pick a trim: it tells us the exact body and bumper.'); return; }
        say(''); pendAt = Date.now(); carSet({ y: my.value, m: mm.value, t: mt.value || '' });
      });
      function vl() { UI = boxUI; pendAt = Date.now(); vlook(); }
      boxUI.go.addEventListener('click', vl);
      boxUI.inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); vl(); } });
      saved.querySelector('[data-mv-chg]').addEventListener('click', function () {
        saved.hidden = true; fields.hidden = false;
        ensure().then(function () { var c = carGet(); if (c && list && list[c.y]) { my.value = c.y; refreshBox(); mm.value = c.m; refreshBox(); mt.value = c.t || ''; sync(); } });
      });
      document.addEventListener('atman:car', function () {
        paint();
        if (pendAt && Date.now() - pendAt < 20000) { pendAt = 0; if (window.__welcomeSoon) window.__welcomeSoon(20000); }
      });
      paint();
    })();
    // Строки поиска: VIN вместо детали (17 знаков без пробелов, цифры и буквы, без I O Q) определяет машину, а не ищет по названию.
    function vinQ(s) {
      var v = String(s || '').trim().toUpperCase();
      return /^[A-HJ-NPR-Z0-9]{17}$/.test(v) && /\d/.test(v) && /[A-Z]/.test(v) ? v : '';
    }
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action$="/search"]')) return;
      var q = f.querySelector('input[name="q"]'), v = q ? vinQ(q.value) : '';
      if (!v) return;
      e.preventDefault(); e.stopImmediatePropagation();
      vinEl.value = v; vlookPop(q);
    }, true);
    // Страница поиска, открытая по ссылке с VIN в запросе (например «See all results» из подсказок).
    if (/^\/search\/?$/.test(location.pathname)) {
      var sv = vinQ(new URLSearchParams(location.search).get('q'));
      if (sv) { vinEl.value = sv; vlookPop({ land: true }); }
    }
    // Подсказки в строках поиска на телефоне (11.10.2026): полный текст не влезает и слово VIN обрезается, поэтому там короткий.
    (function () {
      var mq = window.matchMedia ? window.matchMedia('(max-width:740px)') : null;
      function setPh() {
        [].slice.call(document.querySelectorAll('form[action$="/search"] input[name="q"]')).forEach(function (i) {
          if (!i.hasAttribute('data-ph-full')) i.setAttribute('data-ph-full', i.placeholder);
          i.placeholder = mq && mq.matches ? (i.form && i.form.classList.contains('herob-search') ? 'Part no. or VIN' : 'Part number or VIN') : i.getAttribute('data-ph-full');
        });
      }
      setPh();
      if (mq) { if (mq.addEventListener) mq.addEventListener('change', setPh); else if (mq.addListener) mq.addListener(setPh); }
    })();
    try { var pm = sessionStorage.getItem('atman_vin_toast'); if (pm) { sessionStorage.removeItem('atman_vin_toast'); vtoast(pm); } } catch (e) {}
    goEl.addEventListener('click', function () {
      if (!yEl.value || !mEl.value) { msgEl.textContent = 'Pick a year and a model.'; msgEl.hidden = false; return; }
      if (tEl.options.length > 1 && !tEl.value) { msgEl.textContent = 'Pick a trim: it tells us the exact body and bumper.'; msgEl.hidden = false; return; }
      carSet({ y: yEl.value, m: mEl.value, t: tEl.value || '' });
      close();
      var reg = goEl.getAttribute('data-register'); // гость: после сохранения ведём на регистрацию (вход по коду из письма)
      if (reg) location.href = reg;
    });
  })();

  // Приветственный поп-ап (11.10.2026): машина + имя + email → «10%». Разметка: snippets/welcome-bar.liquid.
  // Машина сохраняется в браузере (как «Your car» в шапке, плюс цвет); имя и email уходят в стандартную форму Shopify
  // `customer` (клиент без аккаунта, подписка, теги welcome-banner / car-year / car-model / car-color), своего сервера нет.
  // Скидку даёт аккаунт, поэтому в конце просим войти с тем же email.
  // LIVE=false: баннер виден только по ?welcome=1 (черновик на утверждение). Когда одобрят, ставим LIVE=true.
  (function () {
    var bar = document.querySelector('[data-welcome]');
    if (!bar) return;
    var LIVE = true; // 11.10.2026: включено всем (до этого было false, и окно показывалось только по ?welcome=1)
    var force = /[?&]welcome=1/.test(location.search);
    var KEY = 'atman_welcome';
    function seen() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function mark(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    if (!force && /^\/cart/.test(location.pathname)) return; // в корзине не мешаем оформлению
    var skipAuto = !force && (!LIVE || seen() || carGet());
    var wbApi = null;
    function boot() {
    var form = bar.querySelector('form'), askEl = bar.querySelector('[data-welcome-ask]'), doneEl = bar.querySelector('[data-welcome-done]');
    var yEl = bar.querySelector('[data-wb-year]'), mEl = bar.querySelector('[data-wb-model]'), cEl = bar.querySelector('[data-wb-color]');
    var nEl = bar.querySelector('[data-wb-name]'), eEl = bar.querySelector('[data-wb-email]'), errEl = bar.querySelector('[data-wb-err]');
    var goEl = bar.querySelector('[data-wb-go]'), tagsEl = bar.querySelector('[data-wb-tags]');
    var src = (document.querySelector('[data-car-add]') || {}).getAttribute ? document.querySelector('[data-car-add]').getAttribute('data-src') : '';
    var list = null;
    function fill(sel, values, ph) {
      sel.innerHTML = '';
      var o0 = document.createElement('option'); o0.value = ''; o0.textContent = ph; sel.appendChild(o0);
      values.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); });
    }
    function sorted(a, numeric) {
      return a.slice().sort(numeric ? function (x, y) { return y - x; } : function (x, y) { return x.localeCompare(y, 'en', { numeric: true }); });
    }
    function showErr(msg) { errEl.textContent = msg; errEl.hidden = !msg; }
    // Модели видны сразу (все, что есть в каталоге); выбранный год сужает список до моделей этого года.
    function models() {
      if (!list) return [];
      if (yEl.value && list[yEl.value]) return sorted(Object.keys(list[yEl.value]));
      var all = {};
      Object.keys(list).forEach(function (y) { Object.keys(list[y]).forEach(function (m) { all[m] = 1; }); });
      return sorted(Object.keys(all));
    }
    function refillModels() {
      var cur = mEl.value, ms = models();
      fill(mEl, ms, 'Model');
      if (ms.indexOf(cur) >= 0) mEl.value = cur;
    }
    if (src) fetch(src).then(function (r) { return r.json(); }).then(function (j) {
      list = j; fill(yEl, sorted(Object.keys(j), true), 'Year'); refillModels(); if (pend) applyPrefill(pend);
    }).catch(function () {});
    yEl.addEventListener('change', refillModels);
    var pend = null; // машина, уже выбранная на странице: подставляем в поля окна, когда список загружен
    function applyPrefill(c) { if (!c || !list || !list[c.y]) return; yEl.value = c.y; refillModels(); mEl.value = c.m; }
    function prefill(c) { pend = c; applyPrefill(c); }

    // Поп-ап по центру: затемнение, страница под ним не прокручивается, закрытие крестиком, Esc или кликом по затемнению.
    function open() {
      [].forEach.call(bar.querySelectorAll('a[data-href]'), function (a) { a.href = a.getAttribute('data-href'); });
      [].forEach.call(bar.querySelectorAll('a[data-login]'), function (a) { a.href = window.__loginUrl || '/account/login'; });   // 25.10.2026 (SEO-специалист, E.6): адреса входа нет в разметке   // 12.10.2026: адрес входа в скрытом окне роботы не видят
      bar.hidden = false; void bar.offsetWidth; bar.classList.add('show');
      document.documentElement.classList.add('welcome-lock');
      setTimeout(function () { try { bar.querySelector('[data-welcome-close]').focus(); } catch (e) {} }, 300);
    }
    function close(why) {
      bar.classList.remove('show'); document.documentElement.classList.remove('welcome-lock');
      setTimeout(function () { bar.hidden = true; }, 250); if (why) mark(why);
    }
    bar.querySelector('[data-welcome-close]').addEventListener('click', function () { close(doneEl.hidden ? 'dismissed' : 'done'); });
    bar.addEventListener('mousedown', function (e) { if (e.target === bar) close(doneEl.hidden ? 'dismissed' : 'done'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bar.hidden) close(doneEl.hidden ? 'dismissed' : 'done'); });
    function done(y, m, name, email) {
      bar.querySelector('[data-wb-hello]').textContent = name;
      bar.querySelector('[data-wb-car]').textContent = y + ' BMW ' + m;
      bar.querySelector('[data-wb-mail]').textContent = email;
      askEl.hidden = true; doneEl.hidden = false;
      mark('done');
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var y = yEl.value, m = mEl.value, c = cEl.value, name = nEl.value.trim(), email = eEl.value.trim();
      if (!y || !m) { showErr('Pick your car’s year and model.'); return; }
      if (!name) { showErr('Please tell us your name.'); nEl.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showErr('Please enter a valid email.'); eEl.focus(); return; }
      showErr(''); goEl.disabled = true; goEl.textContent = 'Sending…';
      carSet({ y: y, m: m, t: '', c: c });
      var tags = ['welcome-banner', 'car-year:' + y, 'car-model:' + m.replace(/,/g, ' ')];
      if (c) tags.push('car-color:' + c);
      tagsEl.value = tags.join(', ');
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).then(function (res) {
        // Shopify просит проверку «я не робот» (hCaptcha): отправляем обычной формой, после проверки он вернёт на эту же страницу.
        // Машина уже сохранена; отмечаем «готово», чтобы баннер не показался снова.
        if (res.url.indexOf('/challenge') > -1) { mark('done'); form.submit(); return; }
        if (res.url.indexOf('contact_posted=true') > -1) { done(y, m, name, email); return; }
        goEl.disabled = false; goEl.textContent = 'Get my 10%';
        showErr('We couldn’t save your email. Please check it and try again.');
      }).catch(function () {
        goEl.disabled = false; goEl.textContent = 'Get my 10%';
        showErr('Something went wrong. Please try again.');
      });
    });
    return { open: open, prefill: prefill };
    }
    if (!skipAuto) { wbApi = boot(); setTimeout(wbApi.open, force ? 300 : 1500); }
    // 12.10.2026: окно можно показать и после выбора машины в блоке «My vehicle» (через 20 секунд), пока его не закрыли и не зарегистрировались
    window.__welcomeSoon = function (ms) {
      // закрытое раньше окно не мешает: после выбора машины показываем один раз за визит; не показываем только тем, кто уже зарегистрировался
      if (!LIVE || seen() === 'done' || /^\/cart/.test(location.pathname)) return;
      try { if (sessionStorage.getItem('atman_wb_soon')) return; sessionStorage.setItem('atman_wb_soon', '1'); } catch (e) {}
      if (!wbApi) wbApi = boot();
      var c = carGet(); if (c) wbApi.prefill(c);
      setTimeout(function () { if (seen() !== 'done' && bar.hidden) wbApi.open(); }, ms);
    };
  })();

  // ---- Custom form validation (replaces the browser's native error bubble) ----
  function clearFieldError(el) {
    el.classList.remove('invalid');
    var nx = el.nextElementSibling;
    if (nx && nx.classList.contains('field-err')) nx.remove();
  }
  function showFieldError(el, msg) {
    clearFieldError(el);
    el.classList.add('invalid');
    var e = document.createElement('div');
    e.className = 'field-err';
    e.textContent = msg;
    el.insertAdjacentElement('afterend', e);
  }
  function checkField(el) {
    var val = (el.value || '').trim();
    var label = el.getAttribute('aria-label') || el.getAttribute('placeholder') || 'This field';
    if (el.hasAttribute('required') && val === '') return label + ' is required';
    if (val !== '') {
      if (el.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) return 'Enter a valid email address';
      var pat = el.getAttribute('pattern');
      if (pat && !new RegExp('^(?:' + pat + ')$').test(val)) return el.getAttribute('title') || 'Check this value';
    }
    return null;
  }
  function validateForm(form) {
    var ok = true, first = null;
    form.querySelectorAll('input, textarea, select').forEach(function (el) {
      if (el.type === 'hidden' || el.disabled) return;
      var err = checkField(el);
      if (err) { showFieldError(el, err); if (!first) first = el; ok = false; }
      else clearFieldError(el);
    });
    if (first) first.focus();
    return ok;
  }
  // errors disappear as soon as the shopper fixes the field
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('invalid')) clearFieldError(e.target);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('invalid')) clearFieldError(e.target);
  }, true);
  // Split a combined "Email or phone" field into structured email / phone hidden
  // fields on submit. Rule: an '@' means email, anything else is a phone. A valid
  // fallback email is used for delivery when the shopper left only a phone, and the
  // raw value is always kept in contact[email-or-phone] for the human record.
  function splitContact(form) {
    var raw = form.querySelector('input[name="contact[email-or-phone]"]');
    if (!raw) return;
    var v = (raw.value || '').trim();
    var emailEl = form.querySelector('input[name="contact[email]"]');
    var phoneEl = form.querySelector('input[name="contact[phone]"]');
    var fbEl = form.querySelector('[data-fallback-email]');
    var fallback = fbEl ? fbEl.getAttribute('data-fallback-email') : '';
    var looksEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
    if (looksEmail) {
      if (emailEl) emailEl.value = v;
      if (phoneEl) phoneEl.value = '';
    } else if (v && v.indexOf('@') === -1) {
      if (phoneEl) phoneEl.value = v;
      if (emailEl) emailEl.value = fallback; // keep a valid sender for delivery
    } else {
      // has '@' but malformed — keep raw only, use fallback so the message still sends
      if (emailEl) emailEl.value = fallback;
      if (phoneEl) phoneEl.value = '';
    }
  }

  // wire every content form with required fields (contact, trade, …)
  document.querySelectorAll('form').forEach(function (form) {
    if (form.hasAttribute('data-vehicle-form')) return; // handled below
    if (!form.querySelector('[required]')) return;
    form.setAttribute('novalidate', 'novalidate');
    form.addEventListener('submit', function (e) {
      if (!validateForm(form)) { e.preventDefault(); return; }
      splitContact(form);
    });
  });

  // Cart helpers: toast + live count, no page reloads
  function atToast(msg, kind) {
    var t = document.querySelector('[data-cart-toast]');
    if (!t) { t = document.createElement('div'); t.setAttribute('data-cart-toast', ''); document.body.appendChild(t); }
    t.className = 'cart-toast ' + (kind || '') + ' show';
    t.textContent = msg;
    clearTimeout(t._to); t._to = setTimeout(function () { t.classList.remove('show'); }, 3200);
  }
  function atSetCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function atMoney(cents) { var p = (cents / 100).toFixed(2).split('.'); return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1]; }
  function atInCart(id) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (it) { return String(it.id) === String(id) || String(it.variant_id) === String(id); });
      });
  }
  function atAdd(id) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js').then(function (x) { return x.json(); }); });
  }
  // Лимит: не больше 5 деталей в одном заказе. Детали штучные (qty=1), поэтому лимит = число позиций в корзине.
  var AT_MAX = 5;
  function atCartState(id) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        return {
          has: items.some(function (it) { return String(it.id) === String(id) || String(it.variant_id) === String(id); }),
          count: cart.item_count || 0
        };
      });
  }

  // "Buy it now" — ensure it's in the cart, then straight to checkout (no double-add)
  document.querySelectorAll('[data-buynow]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form'); if (!form) return;
      var idEl = form.querySelector('[name="id"]'); if (!idEl || !idEl.value) return;
      var id = idEl.value; btn.disabled = true;
      atCartState(id).then(function (s) {
        if (s.has) { window.location.href = '/checkout'; return; }
        if (s.count >= AT_MAX) { atToast('You can add up to ' + AT_MAX + ' parts per order. Need more? Please place a separate order.', 'info'); btn.disabled = false; return; }
        return atAdd(id).then(function () { window.location.href = '/checkout'; });
      }).catch(function () { btn.disabled = false; form.submit(); });
    });
  });

  // "Add to cart" — AJAX, stay on page; one-of-a-kind parts can't be added twice
  document.querySelectorAll('form.buyrow--3').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idEl = form.querySelector('[name="id"]'); if (!idEl || !idEl.value) return;
      var id = idEl.value;
      var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
      atCartState(id).then(function (s) {
        if (s.has) { atToast('You’ve already added this part', 'info'); if (btn) btn.disabled = false; return; }
        if (s.count >= AT_MAX) { atToast('You can add up to ' + AT_MAX + ' parts per order. Need more? Please place a separate order.', 'info'); if (btn) btn.disabled = false; return; }
        return atAdd(id).then(function (cart) { atSetCount(cart.item_count); atToast('Added to cart', 'ok'); if (btn) btn.disabled = false; });
      }).catch(function () { if (btn) btn.disabled = false; atToast('Something went wrong — please try again', 'info'); });
    });
  });

  // Vehicle filter -> results. 24.09.2026: поиск начинается сразу, как только выбрали
  // поле — ждать кнопку Find не нужно, год не обязателен. Модель и раздел ведут прямо
  // в коллекцию (там остаются чипы фильтров, чтобы уточнить выбор дальше); всё
  // остальное — в обычный текстовый поиск, как раньше.
  var vform = document.querySelector('[data-vehicle-form]');
  if (vform) {
    vform.setAttribute('novalidate', 'novalidate');
    var vYear = vform.querySelector('[data-veh="year"]');
    var vModel = vform.querySelector('[data-veh="model"]');
    var vCat = vform.querySelector('[data-veh="cat"]');

    function vehColl(sel) {
      if (!sel || !sel.value) return '';
      var opt = sel.options[sel.selectedIndex];
      return (opt && opt.getAttribute('data-coll')) || '';
    }

    function vehTag(name) {
      return 'ebaycat-' + name.toLowerCase()
        .replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function vehGo() {
      var modelColl = vehColl(vModel);
      var catColl = vehColl(vCat);
      var cat = vCat ? vCat.value : '';
      var url = '';
      if (modelColl) {
        url = '/collections/' + modelColl + (cat ? '/' + vehTag(cat) : '');
      } else if (catColl) {
        url = '/collections/' + catColl;
      } else {
        var parts = [];
        [vYear, vModel, vCat].forEach(function (el) {
          if (el && el.value && !el.disabled && el.value !== el.dataset.placeholder) parts.push(el.value);
        });
        var q = encodeURIComponent(parts.join(' ').trim());
        if (!q) return;
        url = vform.dataset.action + '?q=' + q + '&type=product';
      }
      window.location.href = url;
    }

    vform.addEventListener('submit', function (e) { e.preventDefault(); vehGo(); });
    // 02.10.2026: Model и Part type работают вместе. Раньше выбор любого поля сразу уводил со страницы,
    // и второе поле выбрать было нельзя. Теперь сами переходим, только когда выбраны оба;
    // если выбрано одно — ждём второе поле или кнопку Find (она ведёт по тому, что выбрано).
    [vModel, vCat].forEach(function (el) { if (el) el.addEventListener('change', function () {
      if (vModel && vModel.value && vCat && vCat.value) { vehGo(); return; }
      var go = vform.querySelector('[type="submit"]'); if (go) go.classList.add('go-ready');
    }); });

    // Год сам по себе искать нечего: в выдаче он ловит любое число 2015 в описании.
    // Поэтому год сужает список моделей до поколений, которые в этот год выпускались,
    // а поиск начинается уже с выбора модели.
    if (vYear && vModel) {
      var vAllOpts = [].slice.call(vModel.options);
      function optYears(opt) {
        var t = opt.text;
        var span = t.match(/(\d{4})\s*[\u2013\u2014-]\s*(\d{4})/);
        if (span) return [+span[1], +span[2]];
        var open = t.match(/(\d{4})\s*\+/);
        if (open) return [+open[1], 2100];
        return null;
      }
      function applyYear() {
        var y = parseInt(vYear.value.trim(), 10);
        var on = /^\d{4}$/.test(vYear.value.trim()) && y >= 1990 && y <= 2030;
        var keep = vAllOpts.filter(function (o) {
          if (!o.value) return true;
          if (!on) return true;
          var yr = optYears(o);
          return !yr || (y >= yr[0] && y <= yr[1]);
        });
        if (keep.length === vModel.options.length) return;
        var cur = vModel.value;
        vModel.innerHTML = '';
        keep.forEach(function (o) { vModel.appendChild(o); });
        vModel.value = keep.some(function (o) { return o.value === cur; }) ? cur : '';
        if (!vModel.value) vModel.selectedIndex = 0;
      }
      vYear.addEventListener('input', applyYear);
      vYear.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyYear(); } });
    }
  }

  // Fixed top zone (header + category bar). position:sticky is fragile inside
  // Shopify section wrappers / flex body, so we pin with position:fixed + a body
  // padding to reserve the space. Bulletproof regardless of wrappers.
  var headerEl = document.querySelector('header');
  var catEl = document.querySelector('.catbar');
  var hWrap = headerEl ? (headerEl.closest('.shopify-section') || headerEl) : null;
  var cWrap = catEl ? (catEl.closest('.shopify-section') || catEl) : null;
  function pinTop() {
    if (!hWrap) return;
    hWrap.style.position = 'fixed'; hWrap.style.top = '0';
    hWrap.style.left = '0'; hWrap.style.right = '0'; hWrap.style.zIndex = '100';
    var h = hWrap.offsetHeight;
    if (cWrap) {
      cWrap.style.position = 'fixed'; cWrap.style.left = '0'; cWrap.style.right = '0';
      cWrap.style.zIndex = '90'; cWrap.style.top = h + 'px';
    }
    document.body.style.paddingTop = (h + (cWrap ? cWrap.offsetHeight : 0)) + 'px';
  }
  window.__pinTop = pinTop;
  pinTop();
  window.addEventListener('resize', pinTop);
  window.addEventListener('load', pinTop);

  // Car strip: each series opens a dropdown of its generations. Desktop opens on
  // hover (CSS); touch devices open on tap, one at a time.
  var carGroups = document.querySelectorAll('[data-cats] .cargrp');
  if (carGroups.length && !window.matchMedia('(hover: hover)').matches) {
    carGroups.forEach(function (g) {
      var h = g.querySelector('.cargrp-h');
      if (!h) return;
      h.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !g.classList.contains('open');
        carGroups.forEach(function (o) { if (o !== g) o.classList.remove('open'); });
        g.classList.toggle('open', open);
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cargrp')) carGroups.forEach(function (o) { o.classList.remove('open'); });
    });
  }

  // Live collection counts — refresh past the cached homepage HTML so the
  // "N parts" figure always reflects the current published catalog.
  document.querySelectorAll('[data-live-count]').forEach(function (el) {
    var url = el.getAttribute('data-live-count');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var n = parseInt(t.trim(), 10);
      if (!isNaN(n)) el.textContent = n.toLocaleString('en-US') + ' parts';
    }).catch(function () {});
  });

  // Every small collection counter (cars, categories, sections) refreshed in ONE
  // request, so makes/models/section tallies always match the live catalog.
  var countEls = document.querySelectorAll('[data-count]');
  if (countEls.length) {
    fetch('/collections?view=counts').then(function (r) { return r.json(); }).then(function (map) {
      countEls.forEach(function (el) {
        var h = el.getAttribute('data-count');
        if (!map || !(h in map)) return;
        var hadParts = /parts/i.test(el.textContent);
        el.textContent = map[h].toLocaleString('en-US') + (hadParts ? ' parts' : '');
      });
    }).catch(function () {});
  }

  // Request-parts popup: in-page "#request-parts" links open a modal instead of
  // navigating away; the part context prefills the form.
  var rpModal = document.querySelector('[data-rp-modal]');
  if (rpModal) {
    var rpOffer = rpModal.querySelector('[data-rp-offer]');
    var rpOfferIn = rpModal.querySelector('[data-rp-offer-input]');
    var rpTitle = rpModal.querySelector('[data-rp-title]');
    var rpSub = rpModal.querySelector('[data-rp-sub]');
    var rpSubmit = rpModal.querySelector('[data-rp-submit]');
    var rpBody = rpModal.querySelector('[data-rp-body]');
    var rpPartsLab = rpModal.querySelector('[data-rp-parts-lab]');
    var rpOpen = function (prefill, isOffer) {
      var ta = rpModal.querySelector('[data-rp-parts]');
      if (ta && prefill) ta.value = prefill;
      var src = rpModal.querySelector('[data-rp-source]');
      if (src) src.value = location.pathname;
      if (isOffer) {
        if (rpOffer) rpOffer.hidden = false;
        if (rpOfferIn) rpOfferIn.setAttribute('required', 'required');
        if (rpTitle) rpTitle.textContent = 'Make an offer';
        if (rpSub) rpSub.textContent = 'Name your price for this part — we reply to accept, counter, or let you know.';
        if (rpSubmit) rpSubmit.textContent = 'Send offer';
        if (rpBody) rpBody.value = 'Price offer from atman.parts';
        if (rpPartsLab) rpPartsLab.textContent = 'Part';
      } else {
        if (rpOffer) rpOffer.hidden = true;
        if (rpOfferIn) rpOfferIn.removeAttribute('required');
        // без конкретной детали окно открывают с общих кнопок — заголовок во множественном числе
        if (rpTitle) rpTitle.textContent = prefill ? 'Request this part' : 'Request parts';
        if (rpSub) rpSub.textContent = prefill
          ? 'Send the part and how to reach you — we reply with price, condition and shipping time. No account needed.'
          : 'Send your VIN and the parts you need — we reply with price, condition and shipping time. No account needed.';
        if (rpSubmit) rpSubmit.textContent = 'Request a quote';
        if (rpBody) rpBody.value = 'Parts request from atman.parts';
        if (rpPartsLab) rpPartsLab.textContent = 'Parts needed';
      }
      rpModal.hidden = false; document.body.style.overflow = 'hidden';
      var first = (isOffer && rpOfferIn) ? rpOfferIn : rpModal.querySelector('textarea, input:not([type=hidden])');
      if (first) setTimeout(function () { first.focus(); }, 30);
    };
    var rpClose = function () { rpModal.hidden = true; document.body.style.overflow = ''; };
    document.querySelectorAll('a[href*="#request-parts"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var href = a.getAttribute('href') || '';
        var isOffer = /[?&]offer=1/.test(href);
        var prefill = '';
        try { var m = href.match(/[?&]part=([^#&]+)/); if (m) prefill = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (_) {}
        rpOpen(prefill, isOffer);
      });
    });
    rpModal.querySelectorAll('[data-rp-close]').forEach(function (b) { b.addEventListener('click', rpClose); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !rpModal.hidden) rpClose(); });
    if (/[?&]contact_posted=true/.test(location.search) && rpModal.querySelector('[data-rp-ok]')) rpOpen('');
  }

  // Load-more: append the next page's cards inline instead of navigating away.
  var lmBtns = document.querySelectorAll('[data-load-more]');
  if (lmBtns.length) {
    document.querySelectorAll('[data-pager]').forEach(function (p) { p.style.display = 'none'; });
    // active collection filter (?cat/?color) — appended cards must respect it
    var lmQp = new URLSearchParams(location.search);
    var lmCat = lmQp.get('cat'), lmColor = lmQp.get('color');
    var lmFilter = !!(lmCat || lmColor);
    function lmMatch(c) {
      return (!lmCat || c.getAttribute('data-cat') === lmCat) && (!lmColor || c.getAttribute('data-color') === lmColor);
    }
    function lmVisible() {
      return [].slice.call(document.querySelectorAll('[data-pgrid] .pcard')).filter(function (c) { return c.style.display !== 'none'; }).length;
    }
    function lmUpdateCount() {
      var cnt = document.querySelector('[data-coll-count]'); if (!cnt) return;
      var vis = lmVisible(), total = parseInt(cnt.getAttribute('data-coll-total'), 10);
      // 09.10.2026: при фильтре по цвету точное число деталей (window.__facetExact) считает блок «full-collection facet counts»
      if (lmFilter) cnt.textContent = (window.__facetExact && window.__facetExact > vis) ? vis + ' of ' + window.__facetExact + ' parts' : vis + (vis === 1 ? ' part' : ' parts');
      else if (total && total > vis) cnt.textContent = vis + ' of ' + total + ' parts';
      else cnt.textContent = vis + (vis === 1 ? ' part' : ' parts');
    }
    lmBtns.forEach(function (btn) {
      var lbl = btn.textContent, loads = 0, target = 0;
      function load() {
        var url = btn.getAttribute('data-load-more');
        if (!url || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading'); btn.textContent = 'Loading…';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = document.querySelector('[data-pgrid]');
          var newGrid = doc.querySelector('[data-pgrid]');
          var added = [];
          if (grid && newGrid) {
            // 11.10.2026: после деталей в наличии идут проданные под отдельным заголовком
            if (btn.getAttribute('data-sold-first') === '1' && newGrid.children.length) {
              var dv = document.createElement('div'); dv.className = 'sold-divider'; dv.textContent = 'Sold parts'; grid.appendChild(dv);
              btn.removeAttribute('data-sold-first');
            }
            [].slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); added.push(c); });
          }
          if (lmFilter) added.forEach(function (c) { if (c.classList && c.classList.contains('pcard')) c.style.display = lmMatch(c) ? '' : 'none'; });
          lmUpdateCount();
          var nextBtn = doc.querySelector('[data-load-more]:not([data-load-more=""])');   // 19.10.2026: пустая скрытая кнопка = дальше страниц нет
          if (nextBtn) {
            btn.setAttribute('data-load-more', nextBtn.getAttribute('data-load-more'));
            if (nextBtn.getAttribute('data-sold-first') === '1') btn.setAttribute('data-sold-first', '1');
            btn.classList.remove('is-loading'); btn.textContent = nextBtn.textContent.trim() || lbl;   // 11.10.2026: после «Show sold parts (N)» дальше «Show more parts»
            loads++;
            // filtered view: keep pulling raw pages until ~a full page of MATCHES is added (or a cap)
            if (lmFilter && loads < 25 && lmVisible() < target) load();
          } else {
            btn.classList.remove('is-loading'); btn.textContent = lbl;   // 11.10.2026: без этого после пустого ответа подпись оставалась «Loading…» и всплывала при смене фильтра
            var w = btn.closest('.loadmore-wrap') || btn; w.style.display = 'none';   // не удаляем: при смене фильтра кнопка снова нужна
          }
        }).catch(function () { btn.classList.remove('is-loading'); btn.textContent = lbl; });
      }
      // each click aims to add ~24 more matching parts (not one raw page = a few matches)
      btn.addEventListener('click', function () { loads = 0; target = lmVisible() + 24; load(); });
      // on a filtered view, auto-fill the first batch (~24 matches)
      if (lmFilter) { loads = 0; target = 24; load(); }
    });
    lmUpdateCount();
  }

  // PDP spec tiles: reveal the tooltip on tap for touch devices (desktop uses hover).
  if (!window.matchMedia('(hover: hover)').matches) {
    var specTiles = document.querySelectorAll('.specs.icons .spec');
    if (specTiles.length) {
      specTiles.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          var open = !t.classList.contains('tap-open');
          specTiles.forEach(function (o) { o.classList.remove('tap-open'); });
          if (open) t.classList.add('tap-open');
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.specs.icons .spec')) specTiles.forEach(function (o) { o.classList.remove('tap-open'); });
      });
    }
  }

  // eBay social proof: fill stats + render random reviews from JSON assets
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  if (window.__ebayProofUrl) {
    fetch(window.__ebayProofUrl).then(function (r) { return r.json(); }).then(function (p) {
      document.querySelectorAll('[data-ebay]').forEach(function (el) {
        var k = el.getAttribute('data-ebay'); if (p[k]) el.textContent = p[k];
      });
    }).catch(function () {});
  }
  var reviewsBox = document.querySelector('[data-ebay-reviews]');
  if (reviewsBox && window.__ebayReviewsUrl) {
    var ebayUrl = reviewsBox.getAttribute('data-ebay-url') || 'https://www.ebay.com/str/atmanparts';
    fetch(window.__ebayReviewsUrl).then(function (r) { return r.json(); }).then(function (list) {
      if (!list || !list.length) return;
      var arr = list.slice();
      for (var i = arr.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = arr[i]; arr[i] = arr[j]; arr[j] = t; }
      // 18.09.2026: отзывы одной лентой со стрелками по бокам — листаются все, а не 8 первых после перемешивания.
      reviewsBox.innerHTML = arr.map(function (rv) {
        return '<a class="review-card" href="' + ebayUrl + '" target="_blank" rel="noopener">' +
          '<div class="review-top"><span class="review-stars">★★★★★</span>' +
          (rv.date ? '<span class="review-date">' + escapeHtml(rv.date) + '</span>' : '') +
          '</div>' +
          '<p class="review-text">' + escapeHtml(rv.text) + '</p>' +
          '<span class="review-link">View on eBay ↗</span></a>';
      }).join('');
      var rvWrap = document.createElement('div'); rvWrap.className = 'reviews-wrap';
      reviewsBox.parentNode.insertBefore(rvWrap, reviewsBox); rvWrap.appendChild(reviewsBox);
      [['prev', '‹', 'Previous reviews'], ['next', '›', 'Next reviews']].forEach(function (b) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'rv-nav rv-' + b[0]; btn.textContent = b[1]; btn.setAttribute('aria-label', b[2]);
        btn.addEventListener('click', function () {
          reviewsBox.scrollBy({ left: (b[0] === 'next' ? 1 : -1) * reviewsBox.clientWidth, behavior: 'smooth' });
        });
        rvWrap.appendChild(btn);
      });
      function rvEdges() {
        var sl = reviewsBox.scrollLeft, max = reviewsBox.scrollWidth - reviewsBox.clientWidth;
        rvWrap.classList.toggle('at-start', sl <= 4);
        rvWrap.classList.toggle('at-end', sl >= max - 4);
      }
      reviewsBox.addEventListener('scroll', rvEdges, { passive: true });
      window.addEventListener('resize', rvEdges);
      rvEdges();
      if (window.__pinTop) window.__pinTop();
    }).catch(function () {});
  }

  // Fitment: "Does it fit your BMW?" checker + full compatibility table (product page)
  var fitBox = document.querySelector('[data-fitment]');
  var fitInlineEl = document.querySelector('[data-fit-data]');
  if (fitBox && fitInlineEl) {
    var fitSku = fitBox.getAttribute('data-sku');
    // Таблица совместимости приходит прямо в разметке (метаполе товара).
    var fitInline = null;
    try { fitInline = JSON.parse(fitInlineEl.textContent); } catch (e) { fitInline = null; }
    var fitWrap = {};
    fitWrap[fitSku] = fitInline;
    var fitSource = Promise.resolve(fitWrap);
    fitSource.then(function (all) {
      var entry = all[fitSku];
      if (!entry || !entry.vehicles || !entry.vehicles.length) return; // no data → stays hidden
      var vehicles = entry.vehicles;
      fitBox.hidden = false;
      var cntEl = fitBox.querySelector('[data-fit-count]');
      if (cntEl) cntEl.textContent = 'Compatible with ' + vehicles.length + ' vehicle' + (vehicles.length === 1 ? '' : 's');

      var yEl = fitBox.querySelector('[data-fit-year]');
      var mEl = fitBox.querySelector('[data-fit-model]');
      var tEl = fitBox.querySelector('[data-fit-trim]');
      // Cascading dropdowns: Year narrows Models, Year+Model narrows Trims.
      function uniqSorted(arr, numeric) {
        var out = [];
        arr.forEach(function (v) { if (v && out.indexOf(v) < 0) out.push(v); });
        out.sort(numeric ? function (a, b) { return b - a; } : function (a, b) { return a.localeCompare(b); });
        return out;
      }
      function fill(sel, values, placeholder) {
        var cur = sel.value;
        sel.innerHTML = '';
        var ph = document.createElement('option'); ph.value = ''; ph.textContent = placeholder; sel.appendChild(ph);
        values.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); });
        if (values.indexOf(cur) >= 0) sel.value = cur; // keep prior pick if still valid
      }
      function refresh() {
        fill(yEl, uniqSorted(vehicles.map(function (v) { return v.Year; }), true), 'Year');
        var afterYear = vehicles.filter(function (v) { return !yEl.value || v.Year === yEl.value; });
        fill(mEl, uniqSorted(afterYear.map(function (v) { return v.Model; })), 'Model');
        var afterModel = afterYear.filter(function (v) { return !mEl.value || v.Model === mEl.value; });
        fill(tEl, uniqSorted(afterModel.map(function (v) { return v.Trim; })), 'Trim');
      }
      refresh();
      yEl.addEventListener('change', refresh);
      mEl.addEventListener('change', refresh);

      var chooseEl = fitBox.querySelector('[data-fit-step="choose"]');
      var verdictEl = fitBox.querySelector('[data-fit-verdict]');
      var toneEl = fitBox.querySelector('[data-fit-tone]');
      var markEl = fitBox.querySelector('[data-fit-mark]');
      var photoEl = fitBox.querySelector('[data-fit-photo]');
      var carPhotos = {};
      try { carPhotos = JSON.parse(toneEl.getAttribute('data-photos') || '{}'); } catch (e) {}
      // Картинка машины только там, где кузов известен точно. X5 F15 (2014–2018): обычные комплектации,
      // и отдельно пакет M Sport (другой бампер). X5 M (`M Sport Utility`, `M Edition`) картинки не имеет.
      // Если комплектация не выбрана и среди подходящих смешаны виды, остаётся силуэт.
      var CAR_BASE = [
        // [ключ картинки, модели, с года, по год, комплектация]
        ['e90-lci', /^(323i|325i|328i|328i xDrive|335d|335i|335i xDrive)$/, 2009, 2011, 'Base Sedan 4-Door'],
        ['e60-lci', /^(525i|528i|528i xDrive|528xi|530i|535i|535i xDrive|535xi|550i)$/, 2008, 2010, 'Base Sedan 4-Door'],
        ['f10', /^(528i|528i xDrive|535i|535i xDrive|550i|550i xDrive|ActiveHybrid 5)$/, 2011, 2013, 'Base Sedan 4-Door'],
        ['f06-gc', /^(640i|640i xDrive|650i|650i xDrive) Gran Coupe$/, 2013, 2014, 'Base Sedan 4-Door'],
        ['f12-cv', /^(640i|640i xDrive|650i|650i xDrive)$/, 2012, 2014, 'Base Convertible 2-Door'],
        ['x4-f26-msport', /^X4$/, 2015, 2018, /M Sport Sport Utility/],
        ['f32-msport', /^(428i|428i xDrive|435i|435i xDrive)$/, 2014, 2016, 'M Sport Coupe 2-Door']
      ];
      function x5Kind(tr) {
        if (/M Sport Sport Utility/.test(tr)) return 'x5-f15-msport';
        if (/^M |\bM Sport\b|\bM Edition\b/.test(tr)) return '';
        return 'x5-f15';
      }
      function carPhotoKey(m, y, matches) {
        var yr = parseInt(y, 10);
        if (!matches.length) return '';
        if (m === 'X5' && yr >= 2014 && yr <= 2018) {
          var k = x5Kind(matches[0].Trim || '');
          return matches.every(function (v) { return x5Kind(v.Trim || '') === k; }) ? k : '';
        }
        // Только обычная комплектация и только в годах своего рестайлинга; M, M Sport, Luxury, купе,
        // универсалы и прочие комплектации остаются с силуэтом.
        for (var r = 0; r < CAR_BASE.length; r++) {
          var c = CAR_BASE[r];
          if (yr >= c[2] && yr <= c[3] && c[1].test(m) &&
              matches.every(function (v) { return c[4] instanceof RegExp ? c[4].test(v.Trim || '') : v.Trim === c[4]; })) return c[0];
        }
        return '';
      }
      var vehEl = fitBox.querySelector('[data-fit-vehicle]');
      var badgeEl = fitBox.querySelector('[data-fit-badge]');
      var noteEl = fitBox.querySelector('[data-fit-note]');

      var fitLine = document.querySelector('[data-fit-line]');
      function showVerdict(y, m, t) {
        var matches = vehicles.filter(function (v) { return v.Year === y && v.Model === m && (!t || v.Trim === t); });
        var hit = matches.length > 0;
        var engines = uniqSorted(matches.map(function (v) { return v.Engine; }));

        // Confirm the vehicle the customer entered (echo it back like eBay).
        vehEl.innerHTML = 
          escapeHtml(y) + ' BMW ' + escapeHtml(m) + (t ? ' · ' + escapeHtml(t) : '') +
          (hit && engines.length ? '<span class="fv-eng">' + escapeHtml(engines.join(' · ')) + '</span>' : '');

        if (hit) {
          toneEl.className = 'fv-car ok';
          var pk = carPhotoKey(m, y, matches);
          if (pk && carPhotos[pk]) { photoEl.src = carPhotos[pk]; photoEl.hidden = false; toneEl.classList.add('has-photo'); }
          // Подходит, но картинки этого кузова нет: серый силуэт с зелёной галочкой поверх (галочка в самой картинке)
          else if (carPhotos['gray-ok']) { photoEl.src = carPhotos['gray-ok']; photoEl.hidden = false; toneEl.classList.add('has-photo', 'generic'); }
          else { photoEl.hidden = true; }
          markEl.textContent = '✓';
          badgeEl.className = 'fv-badge ok';
          badgeEl.textContent = 'This part fits';
          noteEl.innerHTML = 'Verified against our eBay fitment data. Genuine OEM, ready to ship from Kaufman, TX.';
        } else {
          toneEl.className = 'fv-car no';
          // Не подходит: серый силуэт с красным крестиком поверх (крестик нарисован в самой картинке)
          if (carPhotos['gray-no']) { photoEl.src = carPhotos['gray-no']; photoEl.hidden = false; toneEl.classList.add('has-photo', 'generic'); }
          else { photoEl.hidden = true; }
          markEl.textContent = '\u2715';
          badgeEl.className = 'fv-badge no';
          badgeEl.textContent = 'Not listed for this vehicle';
          noteEl.textContent = 'We don’t have this exact match on record, but VINs vary. Check your car by VIN below.';
        }
        // Reveal the verdict; reflow before the class so the animation always plays.
        chooseEl.hidden = true;
        verdictEl.hidden = false;
        void verdictEl.offsetWidth;
        verdictEl.classList.add('show');

        // Короткая строка у цены: тот же вердикт, виден без прокрутки до блока совместимости.
        if (fitLine) {
          fitLine.hidden = false;
          fitLine.className = 'fit-line ' + (hit ? 'ok' : 'no');
          fitLine.textContent = (hit ? '✓ Fits your ' : '? Not listed for your ') + carLabel({ y: y, m: m, t: t });
        }
      }

      function hideVerdict() {
        verdictEl.classList.remove('show');
        verdictEl.hidden = true;
        chooseEl.hidden = false;
        if (fitLine) fitLine.hidden = true;
      }

      fitBox.querySelector('[data-fit-go]').addEventListener('click', function () {
        var y = yEl.value, m = mEl.value, t = tEl.value;
        if (!y || !m) {
          (m ? yEl : mEl).focus();
          fitBox.querySelector('[data-fit-count]').textContent = 'Pick a year and model to check.';
          return;
        }
        if (tEl.options.length > 1 && !t) { // комплектация обязательна, если у модели они есть (от неё зависит кузов и бампер)
          tEl.focus();
          fitBox.querySelector('[data-fit-count]').textContent = 'Pick a trim to check.';
          return;
        }
        carSet({ y: y, m: m, t: t || '' }); // запоминаем; вердикт рисует applyCar по событию atman:car
      });

      // Вердикт по запомненной машине: при загрузке страницы и при любой смене/сбросе машины (шапка, другая вкладка).
      function applyCar() {
        var c = carGet();
        if (c) showVerdict(c.y, c.m, c.t || ''); else hideVerdict();
      }
      document.addEventListener('atman:car', applyCar);
      applyCar();
      if (fitLine) fitLine.addEventListener('click', function () {
        fitBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      fitBox.querySelector('[data-fit-reset]').addEventListener('click', function () {
        verdictEl.classList.remove('show');
        verdictEl.hidden = true;
        chooseEl.hidden = false;
        fitBox.querySelector('[data-fit-count]').textContent = 'Compatible with ' + vehicles.length + ' vehicle' + (vehicles.length === 1 ? '' : 's');
      });

      // Таблица на всю ширину страницы под карточкой: заголовок, число машин, фильтр, прокручиваемая таблица
      // с липкой шапкой (04.10.2026). Порядок строк как на eBay: год по убыванию, марка, модель, комплектация.
      var tableWrap = document.querySelector('[data-fit-table]');
      // 08.10.2026: компактный вид «марка → модель, годы · N вариантов», как у WolfAutoParts.
      // Модель — ссылка на поиск «марка модель» (отдельных страниц моделей без шасси у нас нет).
      var total = vehicles.length, groups = {}, makes = [];
      vehicles.forEach(function (v) {
        var mk = v.Make || '', md = v.Model || '', y = parseInt(v.Year, 10) || 0;
        if (!groups[mk]) { groups[mk] = {}; makes.push(mk); }
        var g = groups[mk][md] || (groups[mk][md] = { min: 9999, max: 0, n: 0, rows: [] });
        g.rows.push(v);
        if (y) { g.min = Math.min(g.min, y); g.max = Math.max(g.max, y); }
        g.n++;
      });
      makes.sort();
      var yrs = function (g) { return !g.max ? '' : g.min === g.max ? String(g.min) : g.min + '–' + g.max; };
      var blocks = makes.map(function (mk) {
        var models = Object.keys(groups[mk]).sort(function (a, b) { return a.localeCompare(b, 'en', { numeric: true }); });
        return '<div class="fit-make"><h3>' + escapeHtml(mk) + '</h3><ul class="fit-models">' + models.map(function (md) {
          var g = groups[mk][md], href = '/search?type=product&q=' + encodeURIComponent((mk + ' ' + md).trim());
          var rows = g.rows.slice().sort(function (p, q) {
            return (parseInt(q.Year, 10) || 0) - (parseInt(p.Year, 10) || 0) || String(p.Trim || '').localeCompare(String(q.Trim || ''));
          });
          var hay = (mk + ' ' + md + ' ' + yrs(g) + ' ' + rows.map(function (r) { return [r.Year, r.Trim, r.Engine].join(' '); }).join(' ')).toLowerCase();
          return '<li data-q="' + escapeHtml(hay) + '"><details class="fit-acc"><summary><span class="fit-name">' + escapeHtml(md) + '</span>' +
            '<span class="fit-meta"><span class="fit-yrs">' + yrs(g) + '</span> · ' + g.n + ' variant' + (g.n === 1 ? '' : 's') + '</span>' +
            '<svg class="fit-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></summary>' +
            '<div class="fit-vars">' + rows.map(function (r) {
              return '<div class="fit-var"><span class="fv-y">' + escapeHtml(r.Year || '') + '</span><span class="fv-t">' + escapeHtml(r.Trim || '') + '</span><span class="fv-e">' + escapeHtml(r.Engine || '') + '</span></div>';
            }).join('') + '<a class="fit-go-link" href="' + href + '">View ' + escapeHtml((mk + ' ' + md).trim()) + ' parts &rarr;</a></div></details></li>';
        }).join('') + '</ul></div>';
      }).join('');
      tableWrap.innerHTML = '<div class="wrap pd-compat-in"><h2>Compatibility</h2>' +
        '<p class="fit-sum">This part fits ' + total + ' vehicle' + (total === 1 ? '' : 's') + '</p>' +
        '<div class="fit-tools"><input class="fit-filter" type="search" placeholder="Filter by year, make or model" aria-label="Filter by year, make or model" autocomplete="off" spellcheck="false">' +
        '<span class="fit-count2" role="status"></span></div>' +
        '<div class="fit-groups">' + blocks + '</div>' +
        '<p class="fit-empty" hidden>No vehicle in this list matches your filter.</p>' +
        '</div>';
      var fitRows = [].slice.call(tableWrap.querySelectorAll('.fit-models li'));
      var fitCount = tableWrap.querySelector('.fit-count2'), fitEmpty = tableWrap.querySelector('.fit-empty');
      fitCount.textContent = fitRows.length + ' models';
      tableWrap.querySelector('.fit-filter').addEventListener('input', function () {
        var words = this.value.toLowerCase().split(/\s+/).filter(Boolean), shown = 0;
        fitRows.forEach(function (li) {
          var q = li.getAttribute('data-q'), ok = words.every(function (w) { return q.indexOf(w) > -1; });
          li.hidden = !ok; if (ok) shown++;
        });
        tableWrap.querySelectorAll('.fit-make').forEach(function (m) { m.hidden = !m.querySelector('li:not([hidden])'); });
        fitCount.textContent = shown + ' of ' + fitRows.length + ' models';
        fitEmpty.hidden = shown > 0;
      });
      tableWrap.hidden = false;
    }).catch(function () {});
  }

  // Collection faceted drill-down: ?cat / ?color narrow the model collection,
  // rebuild the breadcrumb chain, and drive two chip rows (Type + Color) with
  // live counts + co-filtering. A chip hides when nothing matches the other axis;
  // a whole row hides when it offers no real choice (e.g. Color inside Engine).
  var collCrumb = document.querySelector('[data-collection-crumb]');
  if (collCrumb) {
    var qp = new URLSearchParams(location.search);
    var fcolor = qp.get('color');
    // 10.10.2026: фильтры рисует сервер (родные фильтры Shopify, блок data-native-facets): цифры, активное
    // состояние и ссылки уже в HTML, сетка уже отфильтрована. Здесь остаётся только заголовок/крошки и цвет плашек.
    var NATIVE = !!document.querySelector('[data-native-facets]');
    if (NATIVE) fcolor = null;
    var model = collCrumb.getAttribute('data-model');
    var base = collCrumb.getAttribute('data-base');
    var root = location.origin + '/';
    var cards = [].slice.call(document.querySelectorAll('.pgrid .pcard'));

    // 24.09.2026: категория фильтруется силами Shopify — тегом ebaycat:<раздел> в адресе
    // (/collections/bmw-f10/ebaycat-interior-parts-accessories). Раньше это был ?cat, который
    // отбирал только уже загруженные 50 карточек и показывал «24 of 762».
    function catTag(name) {
      return 'ebaycat-' + name.toLowerCase()
        .replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    var catSeg = location.pathname.indexOf(base + '/') === 0
      ? location.pathname.slice(base.length + 1).split('/')[0] : '';
    var fcat = null;
    if (catSeg) {
      var hit = [].slice.call(document.querySelectorAll('.facet-cat')).filter(function (ch) {
        return catTag(ch.getAttribute('data-val')) === catSeg;
      })[0];
      fcat = hit ? hit.getAttribute('data-val') : qp.get('cat');
    } else {
      fcat = qp.get('cat');
    }
    if (NATIVE) fcat = null;

    function facetUrl(cat, color) {
      return base + (cat ? '/' + catTag(cat) : '') + (color ? '?color=' + encodeURIComponent(color) : '');
    }

    // 1) фильтруем сетку: категория уже отфильтрована сервером, здесь остаётся цвет
    //    (и старые адреса с ?cat, которые могли остаться в закладках)
    var byServer = !!catSeg;
    var shown = 0;
    cards.forEach(function (c) {
      var okK = byServer || !fcat || c.getAttribute('data-cat') === fcat;
      var okC = !fcolor || c.getAttribute('data-color') === fcolor;
      var vis = okK && okC;
      c.style.display = vis ? '' : 'none';
      if (vis) shown++;
    });

    // 2) breadcrumb chain: Home / Model / [Type] / [Color]
    // 30.09.2026: страница «машина + метка» (раздел или тип детали) — название метки приходит
    // с сервера и остаётся в цепочке, пока покупатель не выбрал фильтр руками.
    var tagLabel = collCrumb.getAttribute('data-tag-label') || '';
    var items = [{ label: 'Home', href: root }, { label: model, href: facetUrl(null, null) }];
    if (tagLabel && !fcat && !fcolor) items.push({ label: tagLabel, href: location.pathname });
    if (fcat) items.push({ label: fcat, href: facetUrl(fcat, null) });
    if (fcolor) items.push({ label: fcolor, href: facetUrl(fcat, fcolor) });
    // 10.10.2026: при родных фильтрах крошки пишет сервер (раздел и тип детали), скрипт их не трогает
    if (!NATIVE) collCrumb.innerHTML = items.map(function (it, i) {
      return i === items.length - 1
        ? '<span>' + escapeHtml(it.label) + '</span>'
        : '<a href="' + it.href + '">' + escapeHtml(it.label) + '</a>';
    }).join(' / ');

    // 3) title + count
    var ttl = document.querySelector('[data-coll-title]');
    // 30.09.2026: заголовок называет машину и категорию вместе («BMW F30 Lighting & Lamps») —
    // так он совпадает с заголовком вкладки и не теряет модель при выборе фильтра.
    if (ttl && !NATIVE) {
      var parts = [model];
      if (tagLabel && !fcat && !fcolor) parts.push(tagLabel);
      if (fcat) parts.push(fcat);
      if (fcolor) parts.push(fcolor);
      ttl.textContent = parts.join(' ');
    }
    var cnt = document.querySelector('[data-coll-count]');
    if (cnt) {
      var total = parseInt(cnt.getAttribute('data-coll-total'), 10);
      if (total && total > shown) cnt.textContent = shown + ' of ' + total + ' parts';
      else cnt.textContent = shown + ' part' + (shown === 1 ? '' : 's');
    }

    // 4) facet chips — co-filtered counts, active state, toggle href, hide empties
    document.querySelectorAll('.facet').forEach(function (chip) {
      var axis = chip.getAttribute('data-facet');
      var val = chip.getAttribute('data-val');
      var isActive = (axis === 'cat' && val === fcat) || (axis === 'color' && val === fcolor);
      var n = cards.filter(function (c) {
        return axis === 'cat'
          ? c.getAttribute('data-cat') === val && (!fcolor || c.getAttribute('data-color') === fcolor)
          : c.getAttribute('data-color') === val && (!fcat || c.getAttribute('data-cat') === fcat);
      }).length;
      var nEl = chip.querySelector('.facet-n');
      // цифру показываем только когда весь раздел уместился на странице — иначе
      // она считалась бы по загруженным карточкам и занижала выдачу
      var cntEl0 = document.querySelector('[data-coll-count]');
      var total0 = cntEl0 ? parseInt(cntEl0.getAttribute('data-coll-total'), 10) : 0;
      if (nEl && !NATIVE && !base) nEl.textContent = (!total0 || total0 <= cards.length) ? n : '';   // 10.10.2026: при точном подсчёте (шаг 7) промежуточные «0» не показываем
      // colour swatch for color chips — derive fill from the value name
      if (axis === 'color') {
        var sw = chip.querySelector('.swatch');
        if (sw && !sw.dataset.done) {
          var toCss = function (t) {
            t = t.trim().toLowerCase();
            if (t === 'wood') return '#8a5a35';   // 12.10.2026: «Wood» не цвет CSS, образец коричневого дерева
            var w = t.split(/\s+/);
            var cands = [t.replace(/\s+/g, ''), w[w.length - 1]];
            for (var i = 0; i < cands.length; i++) {
              if (window.CSS && CSS.supports && CSS.supports('color', cands[i])) return cands[i];
            }
            return '#b9aad6';
          };
          var ps = val.split('/').map(toCss);
          sw.style.background = ps.length > 1
            ? 'linear-gradient(135deg,' + ps[0] + ' 0 50%,' + ps[1] + ' 50% 100%)'
            : ps[0];
          sw.dataset.done = '1';
        }
      }
      if (NATIVE) return; // состояние, ссылки и скрытие пустых значений уже решил сервер
      chip.classList.toggle('on', isActive);
      var newCat = axis === 'cat' ? (isActive ? null : val) : fcat;
      var newColor = axis === 'color' ? (isActive ? null : val) : fcolor;
      chip.setAttribute('href', facetUrl(newCat, newColor));
      var partial = axis === 'cat' && byServer;
      chip.style.display = (n === 0 && !isActive && !partial) ? 'none' : '';
    });

    // 5) hide a row that offers no real choice (all empty, or a single redundant option)
    document.querySelectorAll('.facet-row').forEach(function (row) {
      var chips = [].slice.call(row.querySelectorAll('.facet'));
      var visible = chips.filter(function (ch) { return ch.style.display !== 'none'; });
      var hasActive = chips.some(function (ch) { return ch.classList.contains('on'); });
      row.style.display = (visible.length >= 2 || hasActive) ? '' : 'none';
    });

    // reveal the facets now that they're computed (avoids a flash of all chips)
    var facetsWrap = document.querySelector('[data-facets]');
    if (facetsWrap) facetsWrap.hidden = false;

    // 6) empty intersection — offer a way back
    if (shown === 0 && (fcat || fcolor)) {
      var grid = document.querySelector('.pgrid');
      if (grid && !document.querySelector('.facet-empty')) {
        grid.insertAdjacentHTML('afterend', '<div class="empty facet-empty">No parts match these filters. <a href="' + facetUrl(null, null) + '">Clear filters</a></div>');
      }
    }

    // 7) full-collection facet counts. Steps 1–6 seed the chip numbers from the
    // loaded page only (24 cards), so they add up to 24, not the collection total.
    // On the unfiltered view we pull EXACT per-category / per-color tallies for the
    // whole collection from the lightweight ?view=catcount JSON (rendered in pages
    // of 250 — Shopify's Liquid ceiling — and summed here), so every category that
    // truly exists is shown and the numbers add up to the collection total for any
    // size, with no drift-prone precomputed data. Filtered views keep the loaded
    // co-filtered counts from step 4.
    // 08.10.2026: считаем точные цифры и на странице раздела (fcat задан адресом /ebaycat-…): раньше там
    // оставались цифры по загруженным карточкам, и у всех остальных категорий стоял «0», хотя при клике
    // открывались десятки деталей. Цифры по категориям не зависят от текущей категории; с выбранным
    // цветом оставляем прежний расчёт.
    if (base && !NATIVE) {
      (function fullFacetCounts() {
        var KNOWN = 'body-exterior,electronics-modules,engine,suspension-steering,interior,audio-multimedia,drivetrain-transmission,lighting,fuel-intake,a-c-heating,cooling,wheels-tires,brakes,exhaust'.split(',');
        function handleize(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
        // 09.10.2026: подпись категории в две строки: «Раздел ›» мелко сверху, подкатегория под ней
        // («Bumpers &amp; Components › / Bumpers &amp; Reinforcements»); без подраздела — одна строка.
        function facetLabel(val) {
          var p = String(val).split(' > ');
          return p.length > 1
            ? '<span class="fl"><span class="fl-a">' + escapeHtml(p[0]) + ' ›</span><span class="fl-b">' + escapeHtml(p.slice(1).join(' › ')) + '</span></span>'
            : '<span class="fl"><span class="fl-b">' + escapeHtml(val) + '</span></span>';
        }
        function swatchFill(val) {
          var toCss = function (t) {
            t = t.trim().toLowerCase();
            if (t === 'wood') return '#8a5a35';   // 12.10.2026: «Wood» не цвет CSS, образец коричневого дерева
            var w = t.split(/\s+/);
            var cands = [t.replace(/\s+/g, ''), w[w.length - 1]];
            for (var i = 0; i < cands.length; i++) {
              if (window.CSS && CSS.supports && CSS.supports('color', cands[i])) return cands[i];
            }
            return '#b9aad6';
          };
          var ps = val.split('/').map(toCss);
          return ps.length > 1 ? 'linear-gradient(135deg,' + ps[0] + ' 0 50%,' + ps[1] + ' 50% 100%)' : ps[0];
        }
        function buildChip(axis, val, n) {
          var a = document.createElement('a');
          a.className = 'facet facet-' + (axis === 'cat' ? 'cat' : 'color');
          a.setAttribute('data-facet', axis);
          a.setAttribute('data-val', val);
          a.setAttribute('href', axis === 'cat' ? facetUrl(val, null) : facetUrl(null, val));
          if (axis === 'cat') {
            var id = KNOWN.indexOf(handleize(val)) >= 0 ? handleize(val) : 'default';
            a.innerHTML = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#ci-' + id + '"></use></svg>' + facetLabel(val) + '<i class="facet-n">' + n + '</i>';
            a.setAttribute('title', val);
          } else {
            a.innerHTML = '<span class="swatch" aria-hidden="true"></span>' + escapeHtml(val) + '<i class="facet-n">' + n + '</i>';
            var sw = a.querySelector('.swatch');
            if (sw) { sw.style.background = swatchFill(val); sw.dataset.done = '1'; }
          }
          return a;
        }
        function applyCounts(axis, map) {
          if (!map || !Object.keys(map).length) return; // no data — keep loaded-page counts
          var group = document.querySelector('[data-facet-group="' + axis + '"]');
          var wrap = group ? group.querySelector('.facet-chips') : null;
          var seen = {};
          document.querySelectorAll('.facet[data-facet="' + axis + '"]').forEach(function (chip) {
            var val = chip.getAttribute('data-val');
            seen[val] = true;
            var n = map[val] || 0;
            var nEl = chip.querySelector('.facet-n'); if (nEl) nEl.textContent = n;
            chip.style.display = n > 0 ? '' : 'none';
          });
          if (wrap) {
            Object.keys(map).sort().forEach(function (val) {
              if (seen[val] || !map[val]) return;
              wrap.appendChild(buildChip(axis, val, map[val]));
            });
          }
        }
        function fetchPage(p) {
          // No Accept:application/json header — that makes Shopify serve a different
          // built-in JSON and bypass this ?view= template. Plain fetch returns our JSON.
          return fetch(base + '?view=catcount&page=' + p).then(function (r) { return r.json(); });
        }
        // 10.10.2026: обработку счётчиков вынесли в функцию, чтобы показать цифры из кэша сессии сразу,
        // а свежие подгрузить следом (раньше цифры всегда ждали ответа ?view=catcount и до него стояли «0»).
        function finish(cats, cols, pairs) {
          // 09.10.2026: цифры на фильтрах считаем совместно. Выбран цвет — у разделов число деталей этого цвета;
          // выбран раздел — у цветов число деталей этого раздела. Пары «раздел||цвет» отдаёт ?view=catcount.
          if (fcolor || fcat) {
            var catsF = {}, colsF = {};
            Object.keys(pairs).forEach(function (pk) {
              var ix = pk.lastIndexOf('||'), pc = pk.slice(0, ix), px = pk.slice(ix + 2);
              if (!fcolor || px === fcolor) catsF[pc] = (catsF[pc] || 0) + pairs[pk];
              if (px && (!fcat || pc === fcat)) colsF[px] = (colsF[px] || 0) + pairs[pk];
            });
            if (fcolor) {
              // заголовок страницы считал только загруженные карточки («29 parts», а чёрных деталей 128) — берём точное число
              var exact = fcat ? (catsF[fcat] || 0) : Object.keys(catsF).reduce(function (s, k4) { return s + catsF[k4]; }, 0);
              var cEl = document.querySelector('[data-coll-count]');
              window.__facetExact = exact;
              if (cEl && exact > shown) cEl.textContent = shown + ' of ' + exact + ' parts';
            }
            if (fcolor) cats = catsF;
            if (fcat) cols = colsF;
          }
          applyCounts('cat', cats);
          applyCounts('color', cols);
          document.querySelectorAll('.facet-row').forEach(function (row) {
            var chips = [].slice.call(row.querySelectorAll('.facet'));
            var visible = chips.filter(function (ch) { return ch.style.display !== 'none'; });
            row.style.display = (visible.length >= 2) ? '' : 'none';
          });
        }
        try {
          var cc = JSON.parse(sessionStorage.getItem('catc:' + base) || 'null');
          if (cc && Date.now() - cc.t < 600000) finish(cc.c, cc.k, cc.p);
        } catch (e1) {}
        fetchPage(1).then(function (j) {
          var reqs = [];
          for (var p = 2; p <= (j.pages || 1); p++) reqs.push(fetchPage(p));
          return Promise.all(reqs).then(function (more) {
            var cats = Object.assign({}, j.cats), cols = Object.assign({}, j.colors), pairs = Object.assign({}, j.pairs);
            more.forEach(function (m) {
              for (var k in m.cats) cats[k] = (cats[k] || 0) + m.cats[k];
              for (var k2 in m.colors) cols[k2] = (cols[k2] || 0) + m.colors[k2];
              for (var k3 in m.pairs) pairs[k3] = (pairs[k3] || 0) + m.pairs[k3];
            });
            try { sessionStorage.setItem('catc:' + base, JSON.stringify({ t: Date.now(), c: cats, k: cols, p: pairs })); } catch (e0) {}
            finish(cats, cols, pairs);
          });
        }).catch(function () { /* network/parse failure: keep the loaded-page counts */ });
      })();
    }
  }

  // Contact form: prefill the part field when arriving from an empty state (?part=)
  var reqPart = new URLSearchParams(location.search).get('part');
  if (reqPart) {
    var partInput = document.querySelector('input[name="contact[part]"]');
    if (partInput && !partInput.value) partInput.value = reqPart;
    var msgInput = document.querySelector('textarea[name="contact[body]"]');
    if (msgInput && !msgInput.value) msgInput.value = 'Looking for: ' + reqPart;
  }

  // Floating "message us" widget
  var chatw = document.querySelector('[data-chatw]');
  if (chatw) {
    var card = chatw.querySelector('[data-chatw-card]');
    var fab = chatw.querySelector('[data-chatw-toggle]');
    var close = chatw.querySelector('[data-chatw-close]');
    function toggleChat(open) {
      if (card) card.hidden = open === undefined ? !card.hidden : !open;
    }
    if (fab) fab.addEventListener('click', function () { toggleChat(); });
    if (close) close.addEventListener('click', function () { toggleChat(false); });
  }

  // Open the linked policies section when arriving with a #hash (from the nav)
  if (location.hash && location.hash.length > 1) {
    var polTarget = document.getElementById(location.hash.slice(1));
    if (polTarget && polTarget.classList && polTarget.classList.contains('pol')) {
      polTarget.setAttribute('open', '');
      var y = polTarget.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo(0, y);
    }
  }

  // Cookie consent — show once, remember the choice, signal Shopify if available
  var cbar = document.querySelector('[data-cookiebar]');
  if (cbar) {
    var stored = null;
    try { stored = localStorage.getItem('atman_cookie_consent'); } catch (e) {}
    if (!stored) cbar.hidden = false;
    cbar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cookie]');
      if (!b) return;
      var v = b.getAttribute('data-cookie');
      try { localStorage.setItem('atman_cookie_consent', v); } catch (e) {}
      cbar.hidden = true;
      try {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent(v === 'accept', function () {});
        }
      } catch (e) {}
    });
  }

  // Cart: trash icon → 5s ring countdown with an Undo window, then remove
  function bindCartRemove(el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var href = el.getAttribute('href');
      var line = el.getAttribute('data-remove-line');
      var trashHTML = el.innerHTML;
      var cd = document.createElement('span');
      cd.className = 'cart-countdown';
      cd.innerHTML = '<button type="button" class="cart-undo" data-cart-undo aria-label="Undo remove">' +
        '<svg class="cart-ring" viewBox="0 0 36 36"><circle class="cart-ring-bg" cx="18" cy="18" r="16"></circle>' +
        '<circle class="cart-ring-fg" cx="18" cy="18" r="16"></circle></svg>' +
        '<span class="cart-undo-txt">Undo</span></button>';
      el.replaceWith(cd);
      var fg = cd.querySelector('.cart-ring-fg');
      void cd.offsetWidth; // force reflow so the ring starts empty, then animates to full
      fg.classList.add('run');
      var removeId = el.getAttribute('data-remove-id');
      // AJAX removal: no page reload, so several countdowns can finish independently
      var timer = setTimeout(function () {
        var row = cd.closest('.citem');
        if (!removeId) { window.location.href = href; return; }
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: removeId, quantity: 0 }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (cart) {
            if (row) row.remove();
            var sub = document.querySelector('[data-cart-subtotal]');
            var subCents = sub && sub.getAttribute('data-kind') === 'original' ? cart.original_total_price : cart.total_price;
            if (sub) sub.textContent = atMoney(subCents);
            // доставка и итог: сумма data-ship оставшихся строк (центы; пусто — считается на оплате)
            var shipEl = document.querySelector('[data-cart-ship]'), totEl = document.querySelector('[data-cart-total]');
            if (shipEl && totEl) {
              var ship = 0, unknown = false;
              document.querySelectorAll('.citem[data-ship]').forEach(function (r) { var v = r.getAttribute('data-ship'); if (v === '') unknown = true; else ship += parseInt(v, 10) || 0; });
              shipEl.textContent = unknown ? 'Calculated at checkout' : (ship === 0 ? 'Free' : atMoney(ship));
              totEl.textContent = unknown ? atMoney(subCents) + ' + shipping' : atMoney(subCents + ship);
            }
            atSetCount(cart.item_count);
            if (cart.item_count === 0) window.location.reload();
          })
          .catch(function () { window.location.href = href; });
      }, 5000);
      cd.querySelector('[data-cart-undo]').addEventListener('click', function () {
        clearTimeout(timer);
        var a = document.createElement('a');
        a.className = 'cart-remove';
        a.setAttribute('href', href);
        a.setAttribute('data-remove-line', line);
        if (removeId) a.setAttribute('data-remove-id', removeId);
        a.setAttribute('aria-label', 'Remove item');
        a.innerHTML = trashHTML;
        cd.replaceWith(a);
        bindCartRemove(a);
      });
    });
  }
  document.querySelectorAll('[data-remove-line]').forEach(bindCartRemove);

  // Description / Item specifics tabs
  document.querySelectorAll('[data-ptabs]').forEach(function (box) {
    var tabs = box.querySelectorAll('[data-ptab]');
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-ptab');
        tabs.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        box.querySelectorAll('[data-ppane]').forEach(function (p) { p.hidden = (p.getAttribute('data-ppane') !== name); });
      });
    });
  });

  // Product sort — СЕРВЕРНАЯ пересортировка всего каталога через sort_by в URL.
  // Клиентская сортировка переупорядочивала только загруженные 24 карточки, поэтому
  // «Price: high to low» показывал самый дорогой из первых загруженных, а не из всего
  // каталога (дорогие моторы не всплывали). Теперь меняем адрес — Shopify сортирует всё.
  (function () {
    var sortSel = document.querySelector('[data-sortby]');
    if (!sortSel) return;
    var MAP = { 'price-asc': 'price-ascending', 'price-desc': 'price-descending', 'name-asc': 'title-ascending', 'name-desc': 'title-descending', newest: 'created-descending', oldest: 'created-ascending' };
    var REV = { manual: 'newest', 'price-ascending': 'price-asc', 'price-descending': 'price-desc', 'title-ascending': 'name-asc', 'title-descending': 'name-desc', 'created-descending': 'newest', 'created-ascending': 'oldest', 'best-selling': 'newest' };
    var sb = new URLSearchParams(location.search).get('sort_by');
    var initial = true;                           // программная синхронизация — не навигируем
    sortSel.value = REV[sb] || 'newest';     // 19.09.2026: Featured убран, по умолчанию Newest        // синхронизируем выбор с адресом
    sortSel.addEventListener('change', function () {
      if (initial) return;
      var target = MAP[sortSel.value];
      if (!target) return;
      var u = new URL(location.href);
      u.searchParams.set('sort_by', target);
      u.searchParams.delete('page');              // всегда с первой страницы
      location.href = u.toString();
    });
    // обновляем подпись кастомного dropdown под текущую сортировку (иначе показывает первый пункт)
    sortSel.dispatchEvent(new Event('change', { bubbles: true }));
    initial = false;
  })();

  // Product gallery thumbs
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-thumb]'));
    var dots = [].slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    function showThumb(idx) {
      if (!thumbs.length) return;
      idx = (idx + thumbs.length) % thumbs.length; // wrap around
      var th = thumbs[idx];
      var full = th.dataset.thumb;
      if (main && full) main.src = full;
      thumbs.forEach(function (t) { t.classList.remove('on'); });
      th.classList.add('on');
      if (dots.length) { dots.forEach(function (d) { d.classList.remove('on'); }); if (dots[idx]) dots[idx].classList.add('on'); }
    }
    function currentIndex() {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('on'); });
      return i < 0 ? 0 : i;
    }
    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () { showThumb(i); });
    });
    // Prev/next arrows over the main image (only rendered when >1 photo)
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); showThumb(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); showThumb(currentIndex() + 1); });
    // Swipe on the main image (mobile)
    if (main && thumbs.length > 1) {
      var tx = 0, ty = 0;
      main.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; ty = e.changedTouches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { showThumb(currentIndex() + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
    }
    // Click main image -> zoom (lightbox). Всегда крупно (object-fit в большой сцене),
    // листание влево-вправо по всем фото с зацикливанием: стрелки, клавиши, свайп.
    if (main) {
      function bigSrc(u) {
        if (!u) return u;
        return /([?&])width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=1600')
          : u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=1600';
      }
      function srcAt(i) {
        if (thumbs.length) { var t = thumbs[(i + thumbs.length) % thumbs.length]; return bigSrc(t.dataset.thumb); }
        return bigSrc(main.src);
      }
      main.addEventListener('click', function () {
        var n = thumbs.length || 1;
        var idx = currentIndex();
        var lb = document.createElement('div'); lb.className = 'lightbox';
        var stage = document.createElement('div'); stage.className = 'lb-stage';
        var im = document.createElement('img'); im.alt = main.alt || '';
        stage.appendChild(im);
        var x = document.createElement('button'); x.className = 'lb-x'; x.innerHTML = '&times;'; x.setAttribute('aria-label', 'Close');
        lb.appendChild(stage); lb.appendChild(x);
        var prev = null, next = null;
        if (n > 1) {
          prev = document.createElement('button'); prev.className = 'lb-nav lb-prev'; prev.innerHTML = '‹'; prev.setAttribute('aria-label', 'Previous');
          next = document.createElement('button'); next.className = 'lb-nav lb-next'; next.innerHTML = '›'; next.setAttribute('aria-label', 'Next');
          lb.appendChild(prev); lb.appendChild(next);
        }
        function paint() { im.src = srcAt(idx); if (thumbs.length) showThumb(idx); }
        function go(d) { idx = (idx + d + n) % n; paint(); }
        paint();
        function close() { lb.remove(); document.body.style.overflow = ''; document.removeEventListener('keydown', onKey); }
        function onKey(e) { if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1); }
        if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
        if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
        im.addEventListener('click', function (e) { e.stopPropagation(); }); // клик по фото не закрывает
        var sx = 0, sy = 0;
        stage.addEventListener('touchstart', function (e) { sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (n > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        }, { passive: true });
        lb.addEventListener('click', close); // клик по фону закрывает
        document.addEventListener('keydown', onKey);
        document.body.appendChild(lb); document.body.style.overflow = 'hidden';
      });
    }
  }

  // Collections: "by type" / "by car" browse switch (all-parts page)
  (function () {
    var bar = document.querySelector('[data-browseby]');
    if (!bar) return;
    var tabs = [].slice.call(bar.querySelectorAll('.bb-tab'));
    var panes = [].slice.call(document.querySelectorAll('[data-bb-pane]'));
    var toggle = bar.querySelector('[data-bb-toggle]');
    var current = null;
    var collapsed = false;
    try { collapsed = localStorage.getItem('bbCollapsed') === '1'; } catch (e) {}
    function apply() {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-bb') === current;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // свёрнуто — прячем обе панели; иначе показываем активную
      panes.forEach(function (p) {
        p.hidden = collapsed || p.getAttribute('data-bb-pane') !== current;
      });
      if (toggle) {
        toggle.textContent = collapsed ? 'Show filter' : 'Hide filter';
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      }
    }
    function select(key) { current = key; apply(); }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        // клик по вкладке всегда разворачивает список
        if (collapsed) { collapsed = false; try { localStorage.setItem('bbCollapsed', '0'); } catch (e) {} }
        select(t.getAttribute('data-bb'));
      });
    });
    if (toggle) {
      toggle.addEventListener('click', function () {
        collapsed = !collapsed;
        try { localStorage.setItem('bbCollapsed', collapsed ? '1' : '0'); } catch (e) {}
        apply();
      });
    }
    var initTab = bar.querySelector('.bb-tab.is-on') || tabs[0];
    current = initTab ? initTab.getAttribute('data-bb') : 'car';
    apply();
  })();

  // Predictive search: instant product suggestions + smart "jump to" (guess model/type from the query)
  (function () {
    // Our "brain": chassis/generation codes -> model collection
    var GEN = [
      ['e70', 'X5 2006–2013 (E70)', 'bmw-e70'], ['f15', 'X5 2013–2018 (F15)', 'bmw-f15'], ['e46', '3 Series 1998–2006 (E46)', 'bmw-e46'],
      ['e90', '3 Series 2006–2011 (E90)', 'bmw-e90'], ['e92', '3 Series 2006–2013 (E92)', 'bmw-e92'], ['f30', '3 Series 2012–2019 (F30)', 'bmw-f30'],
      ['g20', '3 Series 2018+ (G20)', 'bmw-g20'], ['f10', '5 Series 2010–2017 (F10)', 'bmw-f10'], ['g30', '5 Series 2016–2023 (G30)', 'bmw-g30'],
      ['e60', '5 Series 2003–2010 (E60)', 'bmw-e60'], ['e63', '6 Series 2003–2010 (E63)', 'bmw-e63'], ['f06', '6 Series 2012–2019 (F06)', 'bmw-f06'],
      ['f22', '2 Series 2013–2021 (F22)', 'bmw-f22'], ['f25', 'X3 2010–2017 (F25)', 'bmw-f25'], ['g01', 'X3 2017–2024 (G01)', 'bmw-g01'],
      ['f39', 'X2 2018–2023 (F39)', 'bmw-f39'], ['f98', 'X4 M 2019–2025 (F98)', 'bmw-f98'], ['8r', 'Audi · 8R', 'audi-8r']
    ];
    var CAT = [
      [/engine|motor|cylinder|turbo|camshaft|piston/, 'Engine', 'engine'],
      [/head ?light|tail ?light|\blamp\b|xenon|\bled\b|\bfog\b|headlamp/, 'Lighting', 'lighting'],
      [/radiator|coolant|cooling|thermostat|water pump/, 'Cooling', 'cooling'],
      [/module|\becu\b|\bdme\b|sensor|control unit|amplifier|cluster|relay/, 'Electronics & Modules', 'electronics-modules'],
      [/bumper|fender|\bdoor\b|hood|trunk|mirror|grille|grill|\bpanel\b|spoiler/, 'Body & Exterior', 'body-exterior'],
      [/\bseat\b|dashboard|\bdash\b|console|interior|armrest/, 'Interior', 'interior'],
      [/suspension|strut|shock|control arm|steering|tie rod|sway bar/, 'Suspension & Steering', 'suspension-steering'],
      [/brake|caliper|rotor|\bpad/, 'Brakes', 'brakes'],
      [/wheel|\btire\b|\brim\b/, 'Wheels & Tires', 'wheels-tires']
    ];

    function norm(s) { // lower + map RU-layout look-alikes to Latin (so "е46" typed on Cyrillic still matches "e46")
      var map = { 'а': 'a', 'в': 'b', 'е': 'e', 'к': 'k', 'м': 'm', 'н': 'h', 'о': 'o', 'р': 'p', 'с': 'c', 'т': 't', 'у': 'y', 'х': 'x' };
      return (s || '').toLowerCase().replace(/[а-я]/g, function (c) { return map[c] || c; }).trim();
    }
    // Полный список шасси BMW (= коллекции bmw-XXX). Для префиксных подсказок:
    // «g3» → G30, «f3» → F30…F39, как «did you mean» на странице поиска. Точные коды
    // из GEN получают красивый ярлык («5 Series · G30»), остальные — просто код.
    var CHASSIS = ['e46', 'e60', 'e63', 'e64', 'e70', 'e71', 'e82', 'e85', 'e88', 'e89', 'e90', 'e92', 'e93', 'f02', 'f06', 'f07', 'f10', 'f12', 'f15', 'f16', 'f22', 'f25', 'f26', 'f30', 'f32', 'f33', 'f34', 'f36', 'f38', 'f39', 'f54', 'f70', 'f83', 'f86', 'f90', 'f97', 'f98', 'g01', 'g02', 'g05', 'g20', 'g22', 'g30'];
    function brain(q) {
      var n = norm(q).replace(/\bbmw\b|\baudi\b/g, ' ').trim(), jumps = [], seen = {};
      GEN.forEach(function (g) {
        if (new RegExp('(^|[^a-z0-9])' + g[0] + '([^a-z0-9]|$)').test(n) && !seen[g[2]]) {
          seen[g[2]] = 1; jumps.push({ label: g[1], url: '/collections/' + g[2], chip: 'model' });
        }
      });
      // префикс/точный код шасси, которого нет в GEN: «g3»→G30, «g22»→G22
      n.split(/[^a-z0-9]+/).forEach(function (tk) {
        if (tk.length >= 2 && tk.length <= 3 && /^[efg]\d/.test(tk)) {
          CHASSIS.forEach(function (code) {
            if (code.indexOf(tk) === 0 && !seen['bmw-' + code]) {
              seen['bmw-' + code] = 1; jumps.push({ label: code.toUpperCase(), url: '/collections/bmw-' + code, chip: 'model' });
            }
          });
        }
      });
      CAT.forEach(function (c) { if (c[0].test(n) && !seen[c[2]]) { seen[c[2]] = 1; jumps.push({ label: c[1], url: '/collections/' + c[2], chip: 'type' }); } });
      return jumps.slice(0, 5);
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    // Search log beacon → our own dashboard (www.natalya.pro/atman-admin).
    // sendBeacon with a text/plain blob is a "simple" cross-origin request, so it
    // fires without a preflight and never blocks or slows the search.
    function logSearch(q, count, kind) {
      try {
        if (!q || q.length < 2) return;
        q = atVinRedact(q);
        var payload = JSON.stringify({ q: q, n: (typeof count === 'number' && count >= 0) ? count : null, k: kind });
        var url = 'https://shtab.atman-parts.com/atman-track/log.php';
        if (navigator.sendBeacon) { navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' })); }
        else { fetch(url, { method: 'POST', body: payload, mode: 'no-cors', keepalive: true }).catch(function () {}); }
      } catch (e) {}
    }

    // Недавние запросы клиента (localStorage, только этот браузер). Prefix-обрезка:
    // «g3» вытесняется «g30 mirror», в списке остаются самые полные запросы.
    function getRecentQ() { try { var a = JSON.parse(localStorage.getItem('atman_recent_q') || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
    function saveRecentQ(q) { q = (q || '').trim(); if (q.length < 2) return; try { var lq = q.toLowerCase(); var a = getRecentQ().filter(function (x) { var lx = x.toLowerCase(); return lx.indexOf(lq) !== 0 && lq.indexOf(lx) !== 0; }); a.unshift(q); localStorage.setItem('atman_recent_q', JSON.stringify(a.slice(0, 6))); } catch (e) {} }

    function initAC(wrap) {
    var input = wrap.querySelector('[data-ac-input]');
    var box = wrap.querySelector('[data-ac]');
    if (!input || !box) return;
    var active = -1;
    function openBox() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function closeBox() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function showRecent() {
      var a = getRecentQ(); if (!a.length) { closeBox(); return; }
      var html = '<div class="ac-lbl ac-lbl-rec">Recent searches<button type="button" class="ac-rec-clr" data-ac-clear>Clear</button></div>';
      a.forEach(function (q) {
        html += '<a class="ac-recent" data-ac-nav data-ac-recent href="/search?q=' + encodeURIComponent(q) + '&type=product"><svg class="ac-rec-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + esc(q) + '</a>';
      });
      box.innerHTML = html; active = -1; openBox();
    }
    function setActive(i) {
      var nodes = box.querySelectorAll('[data-ac-nav]'); if (!nodes.length) return;
      active = (i + nodes.length) % nodes.length;
      nodes.forEach(function (n, idx) { n.classList.toggle('is-active', idx === active); });
      nodes[active].scrollIntoView({ block: 'nearest' });
    }
    function render(products, jumps, q, close, nearest) {
      var html = '';
      if (jumps.length) {
        html += '<div class="ac-lbl">Jump to</div>';
        jumps.forEach(function (j) {
          html += '<a class="ac-jump" data-ac-nav href="' + j.url + '">' + esc(j.label) + '<span class="ac-chip">' + j.chip + '</span></a>';
        });
      }
      if (products.length) {
        html += '<div class="ac-lbl">' + (nearest ? 'Did you mean&hellip;' : 'Parts') + '</div>';
        products.forEach(function (p) {
          var img = p.image ? '<img class="ac-thumb" src="' + p.image + '" alt="" loading="lazy">' : '<span class="ac-thumb"></span>';
          var sub = p.sub ? '<div class="ac-sub">' + esc(p.sub) + '</div>' : '';
          var price = p.price ? '<span class="ac-price">' + esc(p.price) + '</span>' : '';
          html += '<a class="ac-item" data-ac-nav href="' + p.url + '">' + img + '<span class="ac-tx"><span class="ac-tt">' + esc(p.title) + '</span>' + sub + '</span>' + price + '</a>';
        });
      }
      if (!products.length && !jumps.length) {
        html = '<div class="ac-empty">No matches yet &mdash; press Enter to search all parts.</div>';
      } else {
        // Число близких карточек (то же, что уходит в штаб). Предиктив Shopify
        // отдаёт максимум 10, поэтому 10 показываем как «10+».
        var n = (typeof close === 'number' && close > 0) ? close : products.length;
        var ntxt = n >= 10 ? '10+' : ('' + n);
        var lbl = n > 0 ? ('See all ' + ntxt + ' result' + (n === 1 ? '' : 's') + ' for &ldquo;' + esc(q) + '&rdquo;') : ('See all results for &ldquo;' + esc(q) + '&rdquo;');
        html += '<a class="ac-all" data-ac-nav href="/search?q=' + encodeURIComponent(q) + '&type=product">' + lbl + '</a>';
      }
      box.innerHTML = html; active = -1; openBox();
    }

    var timer, logTimer;
    function run() {
      var q = atNormPart(input.value.trim());
      if (q.length < 2) { showRecent(); return; }
      var jumps = brain(q);
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.sku,vendor';
      fetch(url).then(function (r) { return r.json(); }).catch(function () { return {}; }).then(function (d) {
        if (atNormPart(input.value.trim()) !== q) return; // stale response
        var raw = (((d.resources || {}).results || {}).products) || [];
        // Show only HARD matches (every word of the query literally present in the
        // title / part number / type / brand); fall back to nearest matches ONLY
        // when there are no exact ones.
        var qtokens = norm(q).split(/\s+/).filter(Boolean);
        var exactRaw = raw.filter(function (p) {
          var hay = norm((p.title || '') + ' ' + (p.product_type || p.type || '') + ' ' + (p.vendor || '') + ' ' +
            (p.variants || []).map(function (v) { return v.sku || ''; }).join(' '));
          return qtokens.every(function (t) { return hay.indexOf(t) !== -1; });
        });
        var nearest = exactRaw.length === 0 && raw.length > 0;
        var products = (nearest ? raw : exactRaw).map(function (p) {
          return {
            title: p.title, url: p.url, image: p.image || p.featured_image || null,
            price: p.price ? ('$' + p.price) : '',
            sub: p.type || p.vendor || ''
          };
        });
        // «Находит» — число реально близких карточек: сколько подсказок содержат
        // самое узкое слово запроса (обычно название детали), с правкой опечаток.
        // Так «2021 bmw m440i xdrive altonator» даёт 2 (только альтернатор), а не
        // 1000 (OR-счётчик Shopify с потолком) и не 118 (все, где есть хоть bmw).
        // Одно и то же число идёт в «See all N» дропдауна и в штаб — везде одинаково.
        function lev(a, b) {
          var m = a.length, n = b.length, i, j, prev = [], cur = [];
          if (!m) return n; if (!n) return m;
          for (j = 0; j <= n; j++) prev[j] = j;
          for (i = 1; i <= m; i++) {
            cur[0] = i;
            for (j = 1; j <= n; j++) {
              var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
              cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
            }
            for (j = 0; j <= n; j++) prev[j] = cur[j];
          }
          return prev[n];
        }
        function tokenClose(word, hayWords) {
          var thr = word.length <= 4 ? 1 : 2;
          for (var k = 0; k < hayWords.length; k++) {
            var w = hayWords[k];
            if (w.length < 3) continue;
            if (w.indexOf(word) !== -1 || word.indexOf(w) !== -1) return true;
            if (Math.abs(w.length - word.length) <= thr && lev(word, w) <= thr) return true;
          }
          return false;
        }
        var hayList = raw.map(function (p) {
          return norm((p.title || '') + ' ' + (p.product_type || p.type || '') + ' ' + (p.vendor || '') + ' ' +
            (p.variants || []).map(function (v) { return v.sku || ''; }).join(' ')).split(/\s+/).filter(Boolean);
        });
        var closeCount = 0;
        qtokens.forEach(function (t) {
          var cov = 0;
          hayList.forEach(function (hw) { if (tokenClose(t, hw)) cov++; });
          if (cov > 0) closeCount = (closeCount === 0) ? cov : Math.min(closeCount, cov);
        });
        render(products, jumps, q, closeCount, nearest);
        // Log the settled query (once typing pauses) with the count of close matches.
        var effCount = closeCount;
        clearTimeout(logTimer);
        (function (qq, cc) {
          logTimer = setTimeout(function () { if (input.value.trim() === qq) { if (cc > 0) saveRecentQ(qq); logSearch(qq, cc, 'live'); } }, 1100);
        })(q, effCount);
      });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 170); });
    if (input.form) input.form.addEventListener('submit', function () { var sv = atNormPart(input.value.trim()); if (sv !== input.value.trim()) input.value = sv; saveRecentQ(sv); logSearch(sv, null, 'submit'); });
    input.addEventListener('focus', function () { var v = input.value.trim(); if (v.length >= 2 && box.innerHTML) openBox(); else if (v.length < 2) showRecent(); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter') {
        var nodes = box.querySelectorAll('[data-ac-nav]');
        if (active >= 0 && nodes[active]) { e.preventDefault(); window.location.href = nodes[active].getAttribute('href'); }
      } else if (e.key === 'Escape') { closeBox(); }
    });
    box.addEventListener('click', function (e) {
      var r = e.target.closest('[data-ac-recent]');
      if (r) { e.preventDefault(); var m = /[?&]q=([^&]*)/.exec(r.getAttribute('href') || ''); var q = m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; input.value = q; input.focus(); run(); return; }
      var c = e.target.closest('[data-ac-clear]');
      if (c) { e.preventDefault(); try { localStorage.removeItem('atman_recent_q'); } catch (_) {} closeBox(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) closeBox(); });
    }
    document.querySelectorAll('[data-search]').forEach(initAC);
  })();


  // Product share: custom popup (copy link + messengers) — no OS share sheet
  (function () {
    var btn = document.querySelector('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-url'), title = btn.getAttribute('data-title') || document.title;
    var pop = null;
    function toast(msg) {
      var t = document.createElement('div'); t.className = 'toast'; t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('on'); });
      setTimeout(function () { t.classList.remove('on'); setTimeout(function () { t.remove(); }, 300); }, 1900);
    }
    function onDoc(e) { if (pop && !pop.contains(e.target) && e.target !== btn && !btn.contains(e.target)) close(); }
    function close() { if (pop) { pop.remove(); pop = null; } document.removeEventListener('click', onDoc); btn.setAttribute('aria-expanded', 'false'); }
    var CH = [
      { k: 'copy', label: 'Copy link' },
      { label: 'WhatsApp', href: 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url) },
      { label: 'Telegram', href: 'https://t.me/share/url?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title) },
      { label: 'Email', href: 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url) },
      { label: 'X', href: 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title) },
      { label: 'Facebook', href: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url) }
    ];
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (pop) { close(); return; }
      pop = document.createElement('div'); pop.className = 'share-pop';
      CH.forEach(function (c) {
        var el = document.createElement(c.href ? 'a' : 'button');
        el.className = 'share-opt'; el.textContent = c.label;
        if (c.href) { el.href = c.href; el.target = '_blank'; el.rel = 'noopener'; el.addEventListener('click', function () { close(); }); }
        else { el.type = 'button'; el.addEventListener('click', function (ev) { ev.preventDefault();
          if (navigator.clipboard) { navigator.clipboard.writeText(url).then(function () { toast('Link copied'); }, function () { toast(url); }); }
          else { toast(url); } close();
        }); }
        pop.appendChild(el);
      });
      btn.parentNode.appendChild(pop);
      btn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { document.addEventListener('click', onDoc); }, 0);
    });
  })();

  // Mobile filters: bottom-sheet toggle
  (function () {
    var openb = document.querySelector('[data-filter-open]');
    var panel = document.querySelector('[data-filters]');
    var scrim = document.querySelector('[data-filter-scrim]');
    if (!openb || !panel || !scrim) return;
    function show() { scrim.hidden = false; requestAnimationFrame(function () { panel.classList.add('open'); scrim.classList.add('on'); }); document.body.style.overflow = 'hidden'; }
    function hide() { panel.classList.remove('open'); scrim.classList.remove('on'); document.body.style.overflow = ''; setTimeout(function () { scrim.hidden = true; }, 300); }
    openb.addEventListener('click', show);
    scrim.addEventListener('click', hide);
    [].forEach.call(document.querySelectorAll('[data-filter-close]'), function (b) { b.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('open')) hide(); });
  })();

  // Catalog card mini-gallery: swipe photos, dots follow scroll
  window.__initCardGalleries = function (root) {
    [].forEach.call((root || document).querySelectorAll('[data-card-gallery] .pimg-track'), function (track) {
      if (track.dataset.galInit) return; track.dataset.galInit = '1';   // 11.10.2026: можно вызывать повторно после подмены сетки каталога
      var dots = track.parentNode.querySelectorAll('.pimg-dot');
      if (dots.length < 2) return;
      // Догрузка кадров 2–6: их адреса лежат в data-src/data-srcset, до первого
      // взаимодействия у видимой карточки грузится только первое фото. Подставляем
      // при наведении/касании/свайпе/фокусе — один раз.
      var card = track.closest('.pcard') || track;
      var hydrated = false;
      function hydrate() {
        if (hydrated) return; hydrated = true;
        [].forEach.call(track.querySelectorAll('img.pimg-defer'), function (im) {
          if (im.dataset.srcset) im.srcset = im.dataset.srcset;
          if (im.dataset.sizes) im.sizes = im.dataset.sizes;
          if (im.dataset.src) im.src = im.dataset.src;
          im.classList.remove('pimg-defer');
        });
        card.removeEventListener('pointerenter', hydrate);
        card.removeEventListener('touchstart', hydrate);
        card.removeEventListener('focusin', hydrate);
        track.removeEventListener('scroll', hydrate);
      }
      card.addEventListener('pointerenter', hydrate);
      card.addEventListener('touchstart', hydrate, { passive: true });
      card.addEventListener('focusin', hydrate);
      track.addEventListener('scroll', hydrate, { passive: true });
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === idx);
        });
      }, { passive: true });
    });
  };
  window.__initCardGalleries();

  // «Fits your car» на карточках каталога (12.10.2026): по запомненной машине и компактной совместимости из data-fit
  // («Модель|Комплектация:годы;…», метаполе custom.fit_compact). Правило то же, что на странице товара: год и модель совпадают,
  // комплектация совпадает, если она выбрана. У карточек без данных вердикта нет.
  (function () {
    function san(s) { return String(s || '').replace(/\|/g, '/').replace(/;/g, ',').replace(/:/g, ' '); }
    function parse(s) {
      var out = [];
      String(s || '').split(';').forEach(function (p) {
        var i = p.lastIndexOf(':'); if (i < 1) return;
        var k = p.slice(0, i).split('|');
        var r = p.slice(i + 1).split(',').map(function (x) { var a = x.split('-'); return [parseInt(a[0], 10), parseInt(a[a.length - 1], 10)]; });
        out.push({ m: k[0], t: k[1] || '', r: r });
      });
      return out;
    }
    function fits(list, c) {
      var y = parseInt(c.y, 10), m = san(c.m), t = san(c.t);
      return list.some(function (e) { return e.m === m && (!t || e.t === t) && e.r.some(function (r) { return y >= r[0] && y <= r[1]; }); });
    }
    function paint(root) {
      var c = carGet();
      [].forEach.call((root || document).querySelectorAll('.pcard[data-fit]'), function (card) {
        var el = card.querySelector('[data-pfit]'); if (!el) return;
        if (!c) { if (!el.hidden) el.hidden = true; var ov0 = card.querySelector('[data-pfit-ov]'); if (ov0 && !ov0.hidden) ov0.hidden = true; card.classList.remove('nofit'); return; }
        if (!card._fit) card._fit = parse(card.getAttribute('data-fit'));
        var ok = fits(card._fit, c), ov = card.querySelector('[data-pfit-ov]');
        // 12.10.2026 (Наталия): подходит — зелёная строка под ценой; не указано — фото приглушено, поверх него «Not listed for your car»
        // 18.10.2026: затемнение не подходящих деталей выключено на время перепроверки фитментов; включить: NOFIT_DIM = true
        var NOFIT_DIM = false, dim = NOFIT_DIM && !ok;
        card.classList.toggle('nofit', dim);
        if (ov && ov.hidden !== !dim) ov.hidden = !dim;
        if (ok) {
          var txt = '✓ Fits your ' + c.y + ' BMW ' + c.m;
          if (el.hidden) el.hidden = false;
          if (el.className !== 'pfit ok') el.className = 'pfit ok';
          if (el.textContent !== txt) el.textContent = txt;   // без лишней записи: иначе наблюдатель ниже зациклится
        } else if (!el.hidden) el.hidden = true;
      });
    }
    window.__paintCardFit = paint;
    document.addEventListener('atman:car', function () { paint(); });
    paint();
    // Карточки появляются позже: «Show more parts», подмена списка при выборе фильтра. Наблюдаем за страницей и докрашиваем новые.
    var tm = 0;
    try {
      new MutationObserver(function () { if (tm) return; tm = setTimeout(function () { tm = 0; paint(); }, 120); }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  })();

  // Mobile sort: bottom-sheet with radio options
  (function () {
    var openb = document.querySelector('[data-sort-open]');
    var panel = document.querySelector('[data-sort-panel]');
    var scrim = document.querySelector('[data-sort-scrim]');
    var sel = document.querySelector('[data-sortby]');
    if (!openb || !panel || !scrim || !sel) return;
    function show() {
      var cur = sel.value;
      [].forEach.call(panel.querySelectorAll('input[name=sortby]'), function (r) { r.checked = (r.value === cur); });
      scrim.hidden = false; requestAnimationFrame(function () { panel.classList.add('open'); scrim.classList.add('on'); }); document.body.style.overflow = 'hidden';
    }
    function hide() { panel.classList.remove('open'); scrim.classList.remove('on'); document.body.style.overflow = ''; setTimeout(function () { scrim.hidden = true; }, 300); }
    openb.addEventListener('click', show);
    scrim.addEventListener('click', hide);
    [].forEach.call(panel.querySelectorAll('[data-sort-close]'), function (b) { b.addEventListener('click', hide); });
    panel.querySelector('[data-sort-apply]').addEventListener('click', function () {
      var r = panel.querySelector('input[name=sortby]:checked');
      if (r) { sel.value = r.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      hide();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('open')) hide(); });
  })();

  // Burger menu: Catalog accordion (by car / by type)
  (function () {
    [].forEach.call(document.querySelectorAll('[data-mn-acc]'), function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (body) body.hidden = open;
      });
    });
  })();

  // Catalog top: desktop click navigates (hover opens menu via CSS); mobile tap toggles submenu
  (function () {
    var cat = document.querySelector('[data-mn-cat]');
    if (!cat) return;
    var isDesktop = function () { return window.matchMedia('(min-width:901px)').matches; };
    var body = cat.nextElementSibling;
    var mncat = cat.closest('.mn-cat');
    // mobile: tap Catalog toggles submenu (desktop: link navigates)
    cat.addEventListener('click', function (e) {
      if (isDesktop()) return;
      e.preventDefault();
      if (body) body.hidden = !body.hidden;
    });
    // desktop: open panel on hover (JS — bulletproof vs CSS :hover)
    if (mncat && body) {
      mncat.addEventListener('mouseenter', function () { if (isDesktop()) body.hidden = false; });
      mncat.addEventListener('mouseleave', function () { if (isDesktop()) body.hidden = true; });
    }
    // By car / By type expand on CLICK only (handled by the data-mn-acc accordion),
    // and collapse the nested lists whenever the Catalog panel closes.
    if (mncat && body) {
      mncat.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        mncat.querySelectorAll('.mn-nest').forEach(function (n) { n.hidden = true; });
        mncat.querySelectorAll('.mn-sub[aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      });
    }
  })();
  // Search results fallback: native search misses partial part numbers -> use predictive (searches SKU)
  (function () {
    var grid = document.querySelector('[data-sku-grid]');
    if (!grid) return;
    var q = atNormPart(grid.getAttribute('data-sku-q') || '');
    if (q.length < 2) return;
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,variants.sku,product_type,vendor';
    fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var ps = (((d.resources || {}).results || {}).products) || [];
      if (!ps.length) return;
      grid.innerHTML = ps.map(function (p) {
        var img = p.image || p.featured_image;
        var imgHtml = img ? '<div class="pimg-track"><img class="pimg-slide" src="' + img + '" alt="" loading="lazy"></div>' : '';
        var price = p.price ? ('$' + p.price) : '';
        var sub = p.type || p.vendor || '';
        return '<a class="pcard" href="' + p.url + '"><div class="pimg">' + imgHtml + '</div>' +
          '<div class="pb"><div class="ttl">' + esc(p.title) + '</div>' +
          (sub ? '<div class="sku">' + esc(sub) + '</div>' : '') +
          '<div class="foot"><span class="price">' + esc(price) + '</span><span class="view">View</span></div></div></a>';
      }).join('');
      grid.hidden = false;
      var empty = document.querySelector('[data-sku-empty]'); if (empty) empty.hidden = true;
      var note = document.querySelector('[data-sku-note]'); if (note) note.hidden = false;
      var cnt = document.querySelector('[data-search-count]'); if (cnt) cnt.textContent = ps.length + ' found';
    }).catch(function () {});
  })();
  // Prefill Request-parts textarea from ?part= (zero-results -> request flow)
  (function () {
    try {
      var q = new URLSearchParams(window.location.search).get('part');
      if (!q) return;
      var ta = document.querySelector('.rp-parts');
      if (ta && !ta.value.trim()) ta.value = q;
    } catch (e) {}
  })();
  // Request-parts form: prevent double submit + smooth-scroll to in-page anchors
  (function () {
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('.rp-form');
      if (!f) return;
      var btn = f.querySelector('[data-rp-submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-scroll]');
      if (!a) return;
      var id = a.getAttribute('href') || '';
      if (id.charAt(0) === '#' && id.length > 1) {
        var el = document.getElementById(id.slice(1));
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  })();

})();

/* Recently viewed — записываем текущий товар и рендерим остальные из localStorage */
(function () {
  var KEY = 'atman_recent';
  var sec = document.querySelector('[data-recent-viewed]');
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) {}
  if (sec && sec.getAttribute('data-cur-handle')) {
    var cur = {
      h: sec.getAttribute('data-cur-handle'),
      t: sec.getAttribute('data-cur-title'),
      p: sec.getAttribute('data-cur-price'),
      img: sec.getAttribute('data-cur-img'),
      u: sec.getAttribute('data-cur-url')
    };
    list = list.filter(function (x) { return x && x.h !== cur.h; });
    list.unshift(cur);
    list = list.slice(0, 16);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  if (!sec) return;
  var track = sec.querySelector('[data-recent-track]');
  var curH = sec.getAttribute('data-cur-handle') || '';
  var items = list.filter(function (x) { return x && x.h && x.h !== curH; }).slice(0, 12);
  if (!items.length || !track) return;
  items.forEach(function (x) {
    var a = document.createElement('a');
    a.className = 'pcard rv-card';
    a.href = x.u || ('/products/' + x.h);
    // 18.09.2026: та же разметка, что у карточек в «More parts» и в ремонтном блоке, — три ленты выглядят одинаково.
    var imWrap = document.createElement('div');
    imWrap.className = 'pimg';
    var trk = document.createElement('div'); trk.className = 'pimg-track'; imWrap.appendChild(trk);
    if (x.img) { var im = document.createElement('img'); im.className = 'pimg-slide'; im.src = x.img; im.loading = 'lazy'; im.alt = x.t || ''; trk.appendChild(im); }
    var pb = document.createElement('div'); pb.className = 'pb';
    var t = document.createElement('div'); t.className = 'ttl'; t.textContent = x.t || '';
    var ft = document.createElement('div'); ft.className = 'foot';
    var p = document.createElement('span'); p.className = 'price'; p.textContent = x.p || '';
    ft.appendChild(p); pb.appendChild(t); pb.appendChild(ft);
    a.appendChild(imWrap); a.appendChild(pb);
    track.appendChild(a);
    // Товар мог быть продан уже после просмотра — снимок в localStorage этого не знает.
    // Проверяем текущее наличие и, если продан, кладём поверх фото бледный слой + метку Sold.
    if (x.h) {
      fetch('/products/' + x.h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pj) {
        if (pj && pj.available === false) {
          a.classList.add('rv-sold');
          var b = document.createElement('span'); b.className = 'sold'; b.textContent = 'Sold';
          imWrap.appendChild(b);
        }
      }).catch(function () {});
    }
  });
  sec.hidden = false;
})();
/* Поиск: переранжировка карточек по близости к запросу (фразовая близость с
   допуском опечатки). Нативный порядок Shopify не учитывает «почти точное» —
   деталь с непрерывной фразой запроса должна стоять выше. */
(function () {
  // 13.09.2026: страница результатов сама пишет в штаб, сколько точных совпадений увидел покупатель
  // (k=page). Раньше в штаб шло только число карточек из подсказки под строкой — и расходилось с
  // выдачей (4 в штабе при 1 точном совпадении). Пишем только с первой страницы выдачи; запрос —
  // как его набрал покупатель (fixedfrom после исправления опечатки), чтобы штаб склеил его с «↵».
  function pageLog(n, m) {
    try {
      var p = new URLSearchParams(location.search);
      if (location.pathname.indexOf('/search') !== 0 || (p.get('page') && p.get('page') !== '1')) return;
      var lq = (p.get('fixedfrom') || p.get('q') || '').trim();
      if (lq.length < 2 || !window.atVinRedact) return;
      lq = window.atVinRedact(lq);
      var body = JSON.stringify({ q: lq, n: n, m: m, k: 'page' }), url = 'https://shtab.atman-parts.com/atman-track/log.php';
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
      else fetch(url, { method: 'POST', body: body, mode: 'no-cors', keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  var grids = document.querySelectorAll('.pgrid');
  if (!grids.length) { pageLog(0, 0); return; }
  var q = '';
  try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
  if (!q) { var h = document.querySelector('.grid-head h2'); if (h) { var m = h.textContent.match(/[“"«](.+?)[”"»]/); if (m) q = m[1]; } }
  // 01.10.2026: запрос — артикул склада (26-FP243). Shopify находит деталь по SKU, а в названии артикула нет,
  // и оценка по названию прятала единственную верную карточку. Для артикула ничего не прячем.
  var isSku = /^\s*\d{2}-[a-z]{2,4}\d{0,5}\s*$/i.test(q || '');
  q = (q || '').toLowerCase().replace(/[^a-z0-9а-яё ]+/gi, ' ').trim();
  var qt = q ? q.split(/\s+/).filter(Boolean) : [];
  if (qt.length < 1) return; // нет запроса — выходим; однословные проходят дальше (заголовок сводим тоже)

  function ed(a, b) { // Левенштейн с отсечкой
    if (a === b) return 0;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 2) return 3;
    var prev = [], i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      var cur = [i];
      for (j = 1; j <= lb; j++) {
        var c = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
      }
      prev = cur;
    }
    return prev[lb];
  }
  function tok(qtok, ttok) {
    if (ttok.indexOf(qtok) >= 0 || qtok.indexOf(ttok) >= 0) return true;
    return ed(qtok, ttok) <= (qtok.length <= 4 ? 1 : 2);
  }
  /* 12.09.2026: оценка по смыслу слов вместо длины совпавшей фразы. Старая считала
     «M440i xDrive» подряд важнее слова «alternator» и путала его с «or» из «Left or Right». */
  /* Новая оценка карточки в поиске: вес слова зависит от того, что это за слово.
     Название детали важнее модели, модель и годы важнее порядка слов, «bmw» не весит ничего. */
  var AIRSUSP = /\bair\s*(suspension|ride|strut|spring)\b|\bairmatic\b|\bair\s+bag\s+(shock|strut|spring|suspension)\b/;
  function makeRanker(qt, ed, tok) {
    var STOP = {bmw:1, oem:1, for:1, the:1, and:1, with:1, w:1, used:1, genuine:1, part:1, parts:1, of:1, to:1};
    var SHORT = {ac:1, o2:1}; // короткие обозначения деталей: A/C, датчик O2
    var FIT = {xdrive:1, sdrive:1, awd:1, rwd:1, fwd:1, coupe:1, convertible:1, sedan:1, wagon:1, touring:1, gran:1,
               hybrid:1, mhev:1, diesel:1, lci:1, cabrio:1, lwb:1, gt:1, m:1, sport:1, msport:1};
    // «328 i» → «328i»
    var toks = [], k;
    for (k = 0; k < qt.length; k++) {
      if (/^\d{2,3}$/.test(qt[k]) && /^[ide]$/.test(qt[k + 1] || '')) { toks.push(qt[k] + qt[k + 1]); k++; }
      else toks.push(qt[k]);
    }
    var terms = [];
    toks.forEach(function (t) {
      if (STOP[t]) return;
      if (/^(19|20)\d{2}$/.test(t)) { terms.push({t: t, kind: 'year', w: 30}); return; }
      if (/\d/.test(t) && /[a-z]/.test(t)) { terms.push({t: t, kind: 'code', w: 60}); return; }
      if (/^\d+$/.test(t)) { terms.push({t: t, kind: 'num', w: 20}); return; }
      if (FIT[t]) { terms.push({t: t, kind: 'fit', w: 25}); return; }
      if (t.length < 3 && !SHORT[t]) return;
      terms.push({t: t, kind: 'part', w: 100});
    });
    var partCount = terms.filter(function (x) { return x.kind === 'part'; }).length;

    function yearHit(year, title) {
      var y = +year, m, re = /\b(\d{2})\s*-\s*(\d{2})\b/g;
      while ((m = re.exec(title))) {
        var a = 2000 + +m[1], b = 2000 + +m[2];
        if (a > b) a -= 100;
        if (y >= a && y <= b) return true;
      }
      return new RegExp('\\b' + year + '\\b').test(title);
    }
    function codeHit(code, tt) {
      for (var i = 0; i < tt.length; i++) {
        if (tt[i] === code) return true;
        if (code.length >= 3 && tt[i].length >= 3 && (tt[i].indexOf(code) === 0 || code.indexOf(tt[i]) === 0)) return true;
      }
      return false;
    }
    function partHit(q, w) {
      if (w === q) return true;
      if (w.length < 3) return false;                          // «or», «w», «a» не считаются
      if (q.length >= 4 && w.length >= 4 && (w.indexOf(q) === 0 || q.indexOf(w) === 0)) return true; // injector/injectors
      if (q.length >= 4 && w.length >= 4) return ed(q, w) <= (q.length <= 5 ? 1 : 2);                // опечатки
      return false;
    }
    var fn = function score(title) {
      var low = title.toLowerCase().replace(/&amp;/g, '&');
      var tt = low.replace(/[^a-z0-9а-яё ]+/gi, ' ').split(/\s+/).filter(Boolean);
      // 10.10.2026: пневмоподвеска. В названиях одна и та же система зовётся «Air Suspension», «Air Ride»,
      // «Airmatic», «Air Strut/Spring», «Air Bag Shock» (у G11/G12 все стойки воздушные). Запрос «air suspension»
      // не находил «Air Ride Shock Strut» и показывал «No exact match». Для таких названий достраиваем недостающие
      // слова в конец списка слов (видимое название не меняется). Голый «Air Bag» — это подушка безопасности,
      // его не трогаем: нужен «shock/strut/spring/suspension» следом.
      if (AIRSUSP.test(low)) tt = tt.concat(['air', 'suspension', 'ride', 'airmatic']);
      var s = 0, parts = 0, hitIdx = [], codesOk = true;
      terms.forEach(function (x) {
        var hit = false, i;
        if (x.kind === 'year') hit = yearHit(x.t, low);
        else if (x.kind === 'code') hit = codeHit(x.t, tt);
        else if (x.kind === 'num') { for (i = 0; i < tt.length; i++) if (tt[i] === x.t || tt[i].indexOf(x.t) === 0) { hit = true; break; } }
        else { for (i = 0; i < tt.length; i++) if (partHit(x.t, tt[i])) { hit = true; hitIdx.push(i); break; } }
        if (hit) { s += x.w; if (x.kind === 'part') parts++; }
        else if (x.kind === 'code') codesOk = false;   // модель из запроса в названии не нашлась
      });
      if (partCount && parts === partCount) s += 200;      // все слова про деталь нашлись
      hitIdx.sort(function (a, b) { return a - b; });       // слова детали стоят рядом — чуть выше
      for (var j = 1; j < hitIdx.length; j++) if (hitIdx[j] - hitIdx[j - 1] === 1) s += 5;
      score.info = {parts: parts, lastIdx: hitIdx.length ? hitIdx[hitIdx.length - 1] : -1, codesOk: codesOk, tt: tt};
      return s * 10 + (title.length < 90 ? 1 : 0);
    };
    fn.terms = terms; fn.partCount = partCount;
    return fn;
  }
  /* 13.09.2026: «точное совпадение» — только сама деталь и для этой модели.
     Раньше счётчик находил слово запроса в названии и называл «точными» два кабеля
     генератора на запрос «alternator», хотя самого генератора на складе не было.
     Ярусы: 0 — сама деталь для этой модели; 1 — её часть или крепёж (слово детали есть,
     но за ним идёт cable / bracket / hose…); 2 — другие детали этой машины; 3 — другая модель.
     Модель важнее всего (так сказал Виталик): деталь не той модели точной не бывает. */
  var score = makeRanker(qt, ed, tok);
  var COMP = {cable:1, cables:1, wire:1, wiring:1, harness:1, bracket:1, brackets:1, mount:1, mounts:1, pulley:1,
    belt:1, bolt:1, bolts:1, cover:1, hose:1, hoses:1, pipe:1, pipes:1, line:1, lines:1, sensor:1, switch:1, relay:1,
    plug:1, connector:1, clip:1, clips:1, seal:1, gasket:1, shield:1, tensioner:1, trim:1, bezel:1, handle:1, knob:1,
    cap:1, lid:1, tube:1, duct:1, bushing:1, bearing:1, tank:1, reservoir:1, filler:1, neck:1, actuator:1, regulator:1,
    module:1, fuse:1, terminal:1, lock:1, latch:1, grille:1, molding:1, moulding:1, emblem:1, washer:1, nozzle:1};
  var STOPSCAN = {w:1, 'with':1, and:1, set:1, pair:1, oem:1, assembly:1, assy:1, left:1, right:1, front:1, rear:1,
    driver:1, passenger:1, side:1, or:1, upper:1, lower:1, inner:1, outer:1};
  function tierOf(title) {
    var s = score(title), i = score.info, pt = 2;   // pt — ярус детали без учёта модели
    if (score.partCount && i.parts >= score.partCount) {
      pt = 0;
      for (var j = i.lastIdx + 1; j < i.tt.length; j++) {
        var w = i.tt[j];
        if (/\d/.test(w) || STOPSCAN[w]) break;
        if (COMP[w]) { pt = 1; break; }
      }
    }
    // 13.09.2026: год из запроса вне диапазона лет в названии («21-26» для 2020) — деталь на эту
    // машину не встаёт, в ближайшие совпадения её не ставим. Нет диапазона в названии — не наказываем.
    var yearsOk = score.terms.every(function (x) { return x.kind !== 'year' || !yearOut(x.t, title); });
    return {s: s, tier: (i.codesOk && yearsOk) ? pt : 3, pt: pt, t: title};
  }
  function yearOut(year, title) {
    var y = +year, m, re = /\b(\d{2})\s*-\s*(\d{2})\b/g, seen = false;
    while ((m = re.exec(title))) {
      var a = 2000 + +m[1], b = 2000 + +m[2];
      if (a > b) a -= 100;                 // «99-05» → 1999–2005
      seen = true;
      if (y >= a && y <= b) return false;  // год попал хотя бы в один диапазон
    }
    return seen;                            // диапазон есть, год ни в один не попал
  }
  // Номер детали BMW пишут полностью (12317616119) и коротко (7616119) — сравниваем по последним семи цифрам.
  function pnKeys(title) {
    var out = [], m, re = /\b\d{7,11}\b/g;
    while ((m = re.exec(title))) out.push(m[0].slice(-7));
    return out;
  }

  var ranked = [];
  [].forEach.call(grids, function (grid, gi) {
    var cards = [].slice.call(grid.querySelectorAll('.pcard'));
    if (!cards.length) return;
    var list = cards.map(function (c, i) {
      var r = tierOf((c.querySelector('.ttl') || {}).textContent || ''); r.c = c; r.i = i; return r;
    });
    // 13.09.2026, сверка по номеру: та же деталь с номером точного совпадения, но снятая
    // с другой машины (генератор 12317616119 стоит и на F07, и на F15) — тоже точное
    // совпадение. Подписываем карточку, чтобы было видно, почему она здесь.
    var pnHit = {};
    list.forEach(function (o) { if (o.tier === 0) pnKeys(o.t).forEach(function (k) { pnHit[k] = 1; }); });
    list.forEach(function (o) {
      if (o.tier !== 3 || o.pt !== 0) return;
      if (!pnKeys(o.t).some(function (k) { return pnHit[k]; })) return;
      o.tier = 0;
      var pb = o.c.querySelector('.pb .ttl');
      if (pb && !o.c.querySelector('.pn-same')) {
        var tag = document.createElement('div');
        tag.className = 'pn-same';
        tag.textContent = 'Same part number';
        pb.parentNode.insertBefore(tag, pb.nextSibling);
      }
    });
    // однословный запрос внутри яруса оставляем в порядке Shopify — для одного слова он и так хорош
    list.sort(function (a, b) { return a.tier - b.tier || (qt.length >= 2 ? b.s - a.s : 0) || a.i - b.i; });
    // 13.09.2026: ярус «другая модель или год вне диапазона» не показываем совсем (решение Наталии).
    // Карточку прячем, а не удаляем: её название ещё нужно исправлению опечаток.
    list.forEach(function (o) { if (o.tier === 3 && !isSku) o.c.style.display = 'none'; grid.appendChild(o.c); });
    if (gi === 0) ranked = list;
  });

  // подпись машины для разделителя: «2021 BMW M440i xDrive»
  var FITNAME = {xdrive: 'xDrive', sdrive: 'sDrive', awd: 'AWD', rwd: 'RWD', fwd: 'FWD', mhev: 'MHEV', lci: 'LCI',
                 lwb: 'LWB', gt: 'GT', m: 'M', msport: 'M Sport'};
  var yearT = '', veh = [];
  score.terms.forEach(function (x) {
    if (x.kind === 'year') yearT = x.t;
    else if (x.kind === 'code') veh.push(x.t.toUpperCase().replace(/([0-9])([IDE])$/, function (m0, d, l) { return d + l.toLowerCase(); }));
    else if (x.kind === 'fit') veh.push(FITNAME[x.t] || (x.t.charAt(0).toUpperCase() + x.t.slice(1)));
  });
  var vehLabel = veh.length ? ((yearT ? yearT + ' ' : '') + 'BMW ' + veh.join(' ')) : '';

  var main = grids[0], head = document.querySelector('.grid-head .sort');
  if (main && ranked.length && score.partCount) {
    var n0 = ranked.filter(function (o) { return o.tier === 0; }).length;
    if (head) head.textContent = n0 ? (n0 + ' exact match' + (n0 === 1 ? '' : 'es')) : 'No exact match';
    if (!main.querySelector('.search-more-sep')) {
      [1, 2].forEach(function (t) {
        var first = null, above = false;
        ranked.forEach(function (o) { if (o.tier < t) above = true; if (!first && o.tier === t) first = o.c; });
        // «More parts for …» подписываем всегда: без подписи детали машины читаются как ближайшие совпадения.
        // Остальные разделители — только когда над ними уже что-то есть.
        if (!first || (!above && t !== 2)) return;
        var sep = document.createElement('div');
        sep.className = 'search-more-sep';
        sep.textContent = t === 1 ? 'Related parts' : t === 2 ? (vehLabel ? 'More parts for ' + vehLabel : 'Other parts') : 'Other models and years';
        sep.style.cssText = 'grid-column:1/-1;margin:18px 0 2px;font-weight:800;font-size:15px;opacity:.72';
        main.insertBefore(sep, first);
      });
    }
  }

  // Исправление опечатки, как у WB: «Showing results for …» над выдачей. Правим только
  // слова из букв от 4 знаков: коды шасси (F30/F10), годы и номера деталей не трогаем —
  // там «похожее» значит «другое». Слово, которое есть хоть в одном названии на странице,
  // опечаткой не считаем; замену берём из названий первых пяти карточек.
  // Исправление опечатки — оформление как у WB (13.09.2026): серая строка НАД заголовком
  // «Showing results for “исправлено”. Search instead for <исходный запрос ссылкой>», а в самом
  // заголовке уже исправленный текст. Ссылка на исходный запрос несёт nocorrect=1 — иначе
  // страница снова исправила бы опечатку и пользователь не смог бы искать как написал.
  // Правим только слова из букв от 4 знаков: коды шасси (F30/F10), годы и номера деталей не трогаем.
  // 13.09.2026: товары тоже берём по исправленному запросу. Shopify слово с опечаткой не узнаёт
  // и требует совпадения всех остальных слов — так из «2022 bmw m440i xdrive altonator» выпадал
  // кабель, в тексте которого нет «xDrive». Поэтому, найдя опечатку, открываем поиск по
  // исправленному тексту с меткой fixedfrom=<как написал покупатель>; на той странице строку
  // «Showing results for …» рисуем по метке и второй раз не исправляем.
  var gh = document.querySelector('.grid-head');
  var rawQ = '', noCorrect = false, fixedFrom = '';
  try {
    var sp = new URLSearchParams(location.search);
    rawQ = sp.get('q') || ''; noCorrect = sp.get('nocorrect') === '1'; fixedFrom = sp.get('fixedfrom') || '';
  } catch (e) {}
  var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };
  var fixed = q;
  if (gh && fixedFrom && !document.querySelector('.search-fixline')) {
    var fl = document.createElement('p');
    fl.className = 'search-fixline';
    fl.innerHTML = 'Showing results for “' + esc(rawQ) + '”. Search instead for ' +
      '<a href="/search?q=' + encodeURIComponent(fixedFrom) + '&amp;type=product&amp;nocorrect=1">' + esc(fixedFrom) + '</a>';
    gh.parentNode.insertBefore(fl, gh);
  }
  if (gh && main && !noCorrect && !fixedFrom) {
    var present = {}, pool = [];
    [].slice.call(main.querySelectorAll('.pcard .ttl')).forEach(function (el, idx) {
      el.textContent.toLowerCase().replace(/[^a-z0-9а-яё ]+/gi, ' ').split(/\s+/).forEach(function (w) {
        if (!w) return;
        present[w] = 1;
        // замену ищем по всем карточкам страницы: нужная деталь может стоять ниже (другой год или модель)
        if (/^[a-zа-яё]{4,}$/i.test(w) && pool.indexOf(w) === -1) pool.push(w);
      });
    });
    var corr = [], changed = false;
    qt.forEach(function (w) {
      if (!/^[a-zа-яё]{4,}$/i.test(w) || present[w]) { corr.push(w); return; }
      var best = w, bd = 99;
      pool.forEach(function (p) { var d = ed(w, p); if (d < bd) { bd = d; best = p; } });
      if (bd > 0 && bd <= (w.length <= 5 ? 1 : 2)) { corr.push(best); changed = true; } else corr.push(w);
    });
    if (changed) {
      fixed = corr.join(' ');
      try {
        var go = new URLSearchParams(location.search);
        go.set('q', fixed); go.set('fixedfrom', rawQ || q); go.delete('page');
        main.style.opacity = '.35';
        location.replace('/search?' + go.toString());
        return;
      } catch (e) {}
      if (!document.querySelector('.search-fixline')) {
        var line = document.createElement('p');
        line.className = 'search-fixline';
        line.innerHTML = 'Showing results for “' + esc(fixed) + '”. Search instead for ' +
          '<a href="/search?q=' + encodeURIComponent(rawQ || q) + '&amp;nocorrect=1">' + esc(rawQ || q) + '</a>';
        gh.parentNode.insertBefore(line, gh);
      }
      var h2 = gh.querySelector('h2');
      if (h2) h2.textContent = 'Results for “' + fixed + '”';
    }
  }
  // Нужной детали нет — говорим прямо под заголовком и предлагаем заявку.
  if (gh && main && score.partCount && ranked.length && !ranked.some(function (o) { return o.tier === 0; }) &&
      !document.querySelector('.search-noexact')) {
    var box = document.createElement('div');
    box.className = 'search-noexact';
    var shown = ranked.some(function (o) { return o.tier !== 3; });
    box.innerHTML = '<div class="sne-none">This exact part isn’t listed right now. ' +
      (shown ? 'Closest matches are below, or ' : 'You can ') +
      '<a href="/pages/contact?part=' + encodeURIComponent(fixed) + '">request this part</a>.</div>';
    gh.parentNode.insertBefore(box, gh.nextSibling);
  }
  // в штаб: точные совпадения, а для запроса без названия детали — сколько карточек видно
  // 10.10.2026: поиск по артикулу склада карточки не прячет (isSku), поэтому и в штаб идёт число
  // всех карточек: раньше деталь находилась, а в штабе стоял 0 (в названии артикула нет, ярус 3)
  var nShown = ranked.filter(function (o) { return isSku || o.tier !== 3; }).length;
  pageLog(isSku ? nShown : score.partCount ? ranked.filter(function (o) { return o.tier === 0; }).length : nShown,
          // и сколько карточек покупатель видит всего (без спрятанного яруса «другая модель»):
          // «0 точных, 2 показано» в штабе отличает пустую страницу от страницы с ближайшими деталями
          nShown);
})();


/* Намёк горизонтальной прокрутки: затухание правого края + пилюля «Swipe 👉»,
   гаснет после первого свайпа и в конце. Работает для всех .related-track
   (More parts / в колонке / Recently viewed — последний наполняется позже). */
(function(){
  function initHScroll(){
    var tracks=document.querySelectorAll('.related-track');
    for(var i=0;i<tracks.length;i++){(function(tr){
      if(tr.dataset.hsInit) return;
      if(tr.scrollWidth - tr.clientWidth <= 8) return; // нечего скроллить
      tr.dataset.hsInit='1';
      var parent=tr.parentElement; if(!parent) return;
      parent.classList.add('hscroll');
      if(!parent.querySelector('.hscroll-hint')){
        var h=document.createElement('div'); h.className='hscroll-hint';
        h.innerHTML='<span>Swipe</span><span class="hnd">\uD83D\uDC49</span>';
        parent.appendChild(h);
      }
      function update(){
        var atEnd = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
        tr.classList.toggle('hs-right', !atEnd);
        if(atEnd) parent.classList.add('hs-off');
      }
      tr.addEventListener('scroll',function(){ parent.classList.add('hs-off'); update(); },{passive:true});
      window.addEventListener('resize',update);
      update();
    })(tracks[i]);}
  }
  if(document.readyState!=='loading') initHScroll(); else document.addEventListener('DOMContentLoaded',initHScroll);
  setTimeout(initHScroll,900); // Recently viewed наполняется JS позже
})();













/* sync 09.10.2026 */
/* 10.10.2026: в журнал поиска пишем и число показанных карточек (m) */
